<template>
    <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black/65">
        <div class="mx-4 w-full p-5">
            <svg
                width="390"
                height="511"
                viewBox="0 0 390 511"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mx-auto max-h-full max-w-full"
            >
                <g filter="url(#filter0_d_26148_72345)">
                    <path
                        d="M365.638 76.4287V422.248C365.638 440.7 350.879 455.66 332.667 455.66H58.1978C39.9856 455.66 25.2266 440.7 25.2266 422.248V76.6238C25.2266 58.1725 39.9928 43.212 58.205 43.212H330.622C330.622 43.212 365.645 39.7862 365.645 76.4287H365.638Z"
                        fill="url(#paint0_linear_26148_72345)"
                    />
                </g>
                <path
                    d="M353.299 79.4573V419.423C353.299 432.461 343.077 443.027 330.471 443.027H60.3871C47.7808 443.027 37.5586 432.461 37.5586 419.423V79.4573C37.5586 66.4193 47.7808 55.8457 60.3871 55.8457H330.478C335.369 55.8457 339.898 57.4429 343.619 60.146C349.478 64.4173 353.307 71.4712 353.307 79.4573H353.299Z"
                    fill="#E88439"
                />
                <path
                    d="M342.96 89.0193V409.861C342.96 422.278 333.41 432.338 321.627 432.338H69.2354C57.4527 432.338 47.9023 422.271 47.9023 409.861V89.0193C47.9023 76.6028 57.4527 66.5352 69.2354 66.5352H321.634C326.207 66.5352 330.441 68.0529 333.916 70.6258C339.391 74.6948 342.967 81.4162 342.967 89.0193H342.96Z"
                    fill="#FFE487"
                    stroke="#781615"
                    stroke-width="5"
                    stroke-miterlimit="10"
                />
                <mask
                    id="mask0_26148_72345"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="48"
                    y="66"
                    width="296"
                    height="367"
                >
                    <path
                        d="M343.273 88.9764V409.819C343.273 422.235 333.722 432.295 321.94 432.295H69.5479C57.7652 432.295 48.2148 422.228 48.2148 409.819V88.9764C48.2148 76.5598 57.7652 66.4922 69.5479 66.4922H321.947C326.52 66.4922 330.753 68.0099 334.228 70.5828C339.704 74.6518 343.28 81.3732 343.28 88.9764H343.273Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_26148_72345)">
                    <g opacity="0.23">
                        <path
                            d="M348.295 176.188V430.683C348.295 433.487 346.012 435.771 343.202 435.771H48.2811C45.4782 435.771 43.1953 433.487 43.1953 430.683V210.481C110.149 409.239 277.411 442.182 348.295 176.188Z"
                            fill="#7A572F"
                        />
                    </g>
                </g>
                <g id="button-red" @click="newGame" :class="loadingAction ? 'cursor-not-allowed opacity-50 pointer-events-none' : 'cursor-pointer'">
                <path
                    d="M303.032 130.945H87.8304C79.5276 130.945 72.7969 137.679 72.7969 145.985V178.971C72.7969 187.277 79.5276 194.011 87.8304 194.011H303.032C311.335 194.011 318.066 187.277 318.066 178.971V145.985C318.066 137.679 311.335 130.945 303.032 130.945Z"
                    fill="#F7D073"
                />
                <path
                    d="M301.459 133.25H89.3995C81.5914 133.25 75.2617 139.582 75.2617 147.394V177.561C75.2617 185.372 81.5914 191.705 89.3995 191.705H301.459C309.267 191.705 315.596 185.372 315.596 177.561V147.394C315.596 139.582 309.267 133.25 301.459 133.25Z"
                    fill="#E88439"
                />
                <path
                    d="M302.823 137.016H88.0477C82.8609 137.016 78.6562 141.222 78.6562 146.411V178.855C78.6562 184.044 82.8609 188.25 88.0477 188.25H302.823C308.01 188.25 312.215 184.044 312.215 178.855V146.411C312.215 141.222 308.01 137.016 302.823 137.016Z"
                    fill="#781615"
                />
                <path
                    d="M302.786 139.242H88.0689C84.0592 139.242 80.8086 142.494 80.8086 146.506V178.761C80.8086 182.773 84.0592 186.025 88.0689 186.025H302.786C306.796 186.025 310.047 182.773 310.047 178.761V146.506C310.047 142.494 306.796 139.242 302.786 139.242Z"
                    fill="#CE0D0D"
                />
                <path
                    d="M305.011 181.11C305.011 181.11 304.975 185.287 302.765 186.025H88.0905C85.8799 185.28 85.8438 181.11 85.8438 181.11L90.33 176.68H300.525L305.011 181.11Z"
                    fill="#BC0606"
                />
                <path
                    d="M90.3301 148.905V176.68L85.8439 181.11C81.9211 180.77 80.8086 178.768 80.8086 178.768V146.506C80.8086 146.506 81.9211 144.504 85.8439 144.164L90.3301 148.905Z"
                    fill="#F92828"
                />
                <path
                    d="M305.011 144.165L300.525 148.906H90.33L85.8438 144.165C85.8438 144.165 85.8799 139.987 88.0905 139.25H302.765C304.975 139.994 305.011 144.165 305.011 144.165Z"
                    fill="#DD1414"
                />
                <path
                    d="M88.0906 139.242C85.88 139.986 85.8439 144.156 85.8439 144.156C81.9211 144.496 80.8086 146.498 80.8086 146.498C80.8086 142.487 84.0595 139.234 88.0689 139.234H88.0906V139.242Z"
                    fill="#CC062C"
                />
                <path
                    d="M310.055 178.768C310.055 182.779 306.805 186.024 302.795 186.024H302.773C304.984 185.279 305.02 181.109 305.02 181.109C308.943 180.77 310.055 178.768 310.055 178.768Z"
                    fill="#CC062C"
                />
                <path
                    d="M310.055 146.504C310.055 146.504 308.943 144.502 305.02 144.163C305.02 144.163 304.984 139.985 302.773 139.248H302.795C306.805 139.248 310.055 142.5 310.055 146.511V146.504Z"
                    fill="#CC062C"
                />
                <path
                    d="M88.0906 186.024H88.0689C84.0595 186.024 80.8086 182.772 80.8086 178.768C80.8086 178.768 81.9211 180.77 85.8439 181.109C85.8439 181.109 85.88 185.287 88.0906 186.024Z"
                    fill="#CC062C"
                />
                <path d="M300.523 148.904H90.3281V176.679H300.523V148.904Z" fill="#E50328" />
                <path
                    d="M132.283 173.071L124.38 164.94V173.071H117.77V156.289H124.474L131.387 163.538V156.289H138.012V173.071H132.283Z"
                    fill="#781615"
                />
                <path
                    d="M139.715 173.071V156.289H157.819V161.587H146.404V162.1H155.709V167.087H146.404V167.773H158.064V173.071H139.715Z"
                    fill="#781615"
                />
                <path
                    d="M174.919 173.071L172.297 164.868L169.653 173.071H163.368L157.234 156.289H164.184L166.676 164.463L169.4 156.289H175.252L177.982 164.463L180.475 156.289H187.33L181.197 173.071H174.919Z"
                    fill="#781615"
                />
                <path
                    d="M202.444 173.57C195.437 173.57 191.254 170.245 191.254 164.68C191.254 159.115 195.437 155.783 202.444 155.783C206.006 155.783 209.127 156.824 211.236 158.703L211.893 159.288L207.508 162.548H212.023V169.891L211.843 170.093C209.892 172.327 206.555 173.562 202.437 173.562L202.444 173.57ZM202.618 161.24C199.634 161.24 198.124 162.396 198.124 164.687C198.124 167.585 200.595 168.2 202.661 168.2C203.896 168.2 204.828 167.997 205.637 167.549V167.405H201.173V162.57H206.526C205.312 161.608 204.243 161.247 202.618 161.247V161.24Z"
                    fill="#781615"
                />
                <path
                    d="M226.725 173.071L225.468 170.419H218.685L217.428 173.071H210.211L218.75 156.297H225.461L234 173.071H226.718H226.725ZM223.164 165.519L222.073 163.199L220.982 165.519H223.157H223.164Z"
                    fill="#781615"
                />
                <path
                    d="M250.052 173.071V165.367L245.53 170.924H244.583L240.076 165.374V173.071H233.473V156.289H240.393L245.19 162.519L250.023 156.289H256.792V173.071H250.052Z"
                    fill="#781615"
                />
                <path
                    d="M258.496 173.071V156.289H276.6V161.587H265.186V162.1H274.49V167.087H265.186V167.773H276.846V173.071H258.496Z"
                    fill="#781615"
                />
                <path
                    d="M132.236 173.028L124.333 164.897V173.028H117.723V156.246H124.427L131.34 163.495V156.246H137.965V173.028H132.236Z"
                    fill="#781615"
                />
                <path
                    d="M139.668 173.028V156.246H157.772V161.544H146.358V162.057H155.662V167.044H146.358V167.73H158.017V173.028H139.668Z"
                    fill="#781615"
                />
                <path
                    d="M174.872 173.028L172.25 164.825L169.606 173.028H163.321L157.188 156.246H164.137L166.63 164.42L169.353 156.246H175.205L177.935 164.42L180.428 156.246H187.284L181.15 173.028H174.872Z"
                    fill="#781615"
                />
                <path
                    d="M202.397 173.527C195.39 173.527 191.207 170.202 191.207 164.637C191.207 159.072 195.39 155.74 202.397 155.74C205.959 155.74 209.08 156.781 211.189 158.66L211.847 159.245L207.461 162.505H211.977V169.848L211.796 170.05C209.845 172.284 206.508 173.519 202.39 173.519L202.397 173.527ZM202.571 161.197C199.587 161.197 198.077 162.353 198.077 164.644C198.077 167.542 200.548 168.157 202.614 168.157C203.849 168.157 204.781 167.954 205.59 167.506V167.362H201.126V162.527H206.479C205.265 161.565 204.196 161.204 202.571 161.204V161.197Z"
                    fill="#781615"
                />
                <path
                    d="M226.679 173.029L225.422 170.376H218.638L217.381 173.029H210.164L218.703 156.254H225.414L233.953 173.029H226.671H226.679ZM223.117 165.476L222.026 163.156L220.935 165.476H223.11H223.117Z"
                    fill="#781615"
                />
                <path
                    d="M250.005 173.028V165.324L245.483 170.881H244.537L240.029 165.331V173.028H233.426V156.246H240.347L245.143 162.476L249.976 156.246H256.745V173.028H250.005Z"
                    fill="#781615"
                />
                <path
                    d="M258.449 173.028V156.246H276.553V161.544H265.139V162.057H274.444V167.044H265.139V167.73H276.799V173.028H258.449Z"
                    fill="#781615"
                />
                <path
                    d="M132.193 172.985L124.29 164.854V172.985H117.68V156.203H124.384L131.297 163.452V156.203H137.922V172.985H132.193Z"
                    fill="#781615"
                />
                <path
                    d="M139.625 172.985V156.203H157.729V161.501H146.315V162.014H155.619V167.001H146.315V167.687H157.974V172.985H139.625Z"
                    fill="#781615"
                />
                <path
                    d="M174.829 172.985L172.207 164.782L169.563 172.985H163.278L157.145 156.203H164.094L166.587 164.377L169.31 156.203H175.162L177.892 164.377L180.385 156.203H187.241L181.107 172.985H174.829Z"
                    fill="#781615"
                />
                <path
                    d="M202.354 173.491C195.347 173.491 191.164 170.167 191.164 164.602C191.164 159.037 195.347 155.705 202.354 155.705C205.916 155.705 209.037 156.746 211.146 158.625L211.804 159.21L207.419 162.47H211.934V169.813L211.753 170.015C209.802 172.248 206.465 173.484 202.347 173.484L202.354 173.491ZM202.528 161.154C199.544 161.154 198.034 162.311 198.034 164.602C198.034 167.5 200.505 168.114 202.571 168.114C203.806 168.114 204.738 167.912 205.547 167.464V167.319H201.083V162.484H206.436C205.222 161.523 204.153 161.162 202.528 161.162V161.154Z"
                    fill="#781615"
                />
                <path
                    d="M226.636 172.986L225.379 170.333H218.595L217.338 172.986H210.121L218.66 156.211H225.371L233.91 172.986H226.628H226.636ZM223.074 165.433L221.983 163.113L220.892 165.433H223.067H223.074Z"
                    fill="#781615"
                />
                <path
                    d="M249.962 172.985V165.281L245.44 170.838H244.494L239.986 165.288V172.985H233.383V156.203H240.304L245.1 162.433L249.933 156.203H256.703V172.985H249.962Z"
                    fill="#781615"
                />
                <path
                    d="M258.406 172.985V156.203H276.51V161.501H265.096V162.014H274.401V167.001H265.096V167.687H276.756V172.985H258.406Z"
                    fill="#781615"
                />
                <path
                    d="M132.15 172.94L124.247 164.809V172.94H117.637V156.158H124.341L131.254 163.407V156.158H137.879V172.94H132.15Z"
                    fill="#781615"
                />
                <path
                    d="M139.582 172.94V156.158H157.686V161.456H146.272V161.969H155.576V166.956H146.272V167.642H157.931V172.94H139.582Z"
                    fill="#781615"
                />
                <path
                    d="M174.786 172.94L172.164 164.737L169.52 172.94H163.235L157.102 156.158H164.051L166.544 164.332L169.267 156.158H175.119L177.849 164.332L180.342 156.158H187.198L181.064 172.94H174.786Z"
                    fill="#781615"
                />
                <path
                    d="M202.311 173.447C195.304 173.447 191.121 170.122 191.121 164.557C191.121 158.992 195.304 155.66 202.311 155.66C205.873 155.66 208.994 156.701 211.103 158.58L211.761 159.165L207.376 162.425H211.891V169.768L211.71 169.97C209.76 172.203 206.422 173.439 202.304 173.439L202.311 173.447ZM202.485 161.11C199.501 161.11 197.991 162.266 197.991 164.557C197.991 167.455 200.462 168.069 202.528 168.069C203.763 168.069 204.695 167.867 205.504 167.419V167.274H201.04V162.439H206.393C205.179 161.478 204.11 161.117 202.485 161.117V161.11Z"
                    fill="#781615"
                />
                <path
                    d="M226.593 172.941L225.336 170.288H218.552L217.295 172.941H210.078L218.617 156.166H225.328L233.867 172.941H226.585H226.593ZM223.031 165.388L221.94 163.068L220.849 165.388H223.024H223.031Z"
                    fill="#781615"
                />
                <path
                    d="M249.919 172.94V165.236L245.397 170.794H244.451L239.95 165.243V172.94H233.34V156.158H240.261L245.057 162.388L249.89 156.158H256.66V172.94H249.919Z"
                    fill="#781615"
                />
                <path
                    d="M258.363 172.94V156.158H276.467V161.456H265.053V161.969H274.358V166.956H265.053V167.642H276.713V172.94H258.363Z"
                    fill="#781615"
                />
                <path
                    d="M132.107 172.897L124.204 164.766V172.897H117.594V156.115H124.298L131.211 163.364V156.115H137.836V172.897H132.107Z"
                    fill="#781615"
                />
                <path
                    d="M139.539 172.897V156.115H157.643V161.413H146.229V161.926H155.533V166.913H146.229V167.599H157.889V172.897H139.539Z"
                    fill="#781615"
                />
                <path
                    d="M174.743 172.897L172.121 164.694L169.477 172.897H163.192L157.059 156.115H164.008L166.501 164.289L169.231 156.115H175.076L177.806 164.289L180.299 156.115H187.155L181.021 172.897H174.743Z"
                    fill="#781615"
                />
                <path
                    d="M202.268 173.404C195.261 173.404 191.078 170.079 191.078 164.514C191.078 158.949 195.261 155.617 202.268 155.617C205.83 155.617 208.951 156.658 211.06 158.537L211.718 159.122L207.333 162.382H211.848V169.725L211.667 169.927C209.717 172.161 206.379 173.396 202.261 173.396L202.268 173.404ZM202.442 161.067C199.458 161.067 197.948 162.223 197.948 164.514C197.948 167.412 200.419 168.026 202.485 168.026C203.72 168.026 204.652 167.824 205.462 167.376V167.231H200.997V162.396H206.35C205.136 161.435 204.067 161.074 202.442 161.074V161.067Z"
                    fill="#781615"
                />
                <path
                    d="M226.55 172.898L225.293 170.245H218.509L217.252 172.898H210.035L218.574 156.123H225.285L233.824 172.898H226.542H226.55ZM222.988 165.345L221.897 163.025L220.806 165.345H222.981H222.988Z"
                    fill="#781615"
                />
                <path
                    d="M249.876 172.897V165.193L245.354 170.751H244.408L239.907 165.2V172.897H233.297V156.115H240.218L245.015 162.345L249.847 156.115H256.617V172.897H249.876Z"
                    fill="#781615"
                />
                <path
                    d="M258.32 172.897V156.115H276.424V161.413H265.01V161.926H274.315V166.913H265.01V167.599H276.67V172.897H258.32Z"
                    fill="#781615"
                />
                <path
                    d="M132.064 172.854L124.161 164.723V172.854H117.551V156.072H124.255L131.168 163.321V156.072H137.793V172.854H132.064Z"
                    fill="#781615"
                />
                <path
                    d="M139.496 172.854V156.072H157.6V161.37H146.186V161.883H155.49V166.87H146.186V167.556H157.846V172.854H139.496Z"
                    fill="#781615"
                />
                <path
                    d="M174.7 172.854L172.078 164.651L169.434 172.854H163.149L157.016 156.072H163.965L166.458 164.246L169.188 156.072H175.04L177.764 164.246L180.256 156.072H187.112L180.978 172.854H174.7Z"
                    fill="#781615"
                />
                <path
                    d="M202.225 173.361C195.218 173.361 191.035 170.036 191.035 164.471C191.035 158.906 195.218 155.574 202.225 155.574C205.787 155.574 208.908 156.615 211.017 158.494L211.675 159.079L207.29 162.339H211.805V169.682L211.624 169.884C209.674 172.118 206.336 173.353 202.218 173.353L202.225 173.361ZM202.399 161.024C199.415 161.024 197.905 162.18 197.905 164.471C197.905 167.369 200.376 167.984 202.442 167.984C203.677 167.984 204.609 167.781 205.419 167.333V167.189H200.954V162.353H206.307C205.093 161.392 204.024 161.031 202.399 161.031V161.024Z"
                    fill="#781615"
                />
                <path
                    d="M226.507 172.855L225.25 170.202H218.466L217.209 172.855H209.992L218.531 156.08H225.242L233.781 172.855H226.499H226.507ZM222.945 165.302L221.854 162.982L220.763 165.302H222.938H222.945Z"
                    fill="#781615"
                />
                <path
                    d="M249.833 172.854V165.15L245.311 170.708H244.365L239.864 165.157V172.854H233.254V156.072H240.175L244.972 162.302L249.805 156.072H256.574V172.854H249.833Z"
                    fill="#781615"
                />
                <path
                    d="M258.277 172.854V156.072H276.381V161.37H264.967V161.883H274.272V166.87H264.967V167.556H276.627V172.854H258.277Z"
                    fill="#781615"
                />
                <path
                    d="M132.021 172.811L124.118 164.68V172.811H117.508V156.029H124.212L131.125 163.278V156.029H137.75V172.811H132.021Z"
                    fill="#781615"
                />
                <path
                    d="M139.453 172.811V156.029H157.557V161.327H146.143V161.84H155.447V166.827H146.143V167.513H157.803V172.811H139.453Z"
                    fill="#781615"
                />
                <path
                    d="M174.657 172.811L172.035 164.608L169.391 172.811H163.106L156.973 156.029H163.922L166.415 164.203L169.145 156.029H174.997L177.721 164.203L180.213 156.029H187.076L180.935 172.811H174.657Z"
                    fill="#781615"
                />
                <path
                    d="M202.182 173.318C195.175 173.318 190.992 169.993 190.992 164.428C190.992 158.863 195.175 155.531 202.182 155.531C205.744 155.531 208.865 156.572 210.974 158.451L211.632 159.037L207.247 162.296H211.762V169.639L211.581 169.841C209.631 172.075 206.293 173.31 202.175 173.31L202.182 173.318ZM202.356 160.981C199.372 160.981 197.862 162.137 197.862 164.428C197.862 167.326 200.333 167.941 202.399 167.941C203.635 167.941 204.566 167.738 205.376 167.29V167.146H200.911V162.31H206.264C205.05 161.349 203.981 160.988 202.356 160.988V160.981Z"
                    fill="#781615"
                />
                <path
                    d="M226.464 172.812L225.207 170.159H218.423L217.166 172.812H209.949L218.488 156.037H225.199L233.738 172.812H226.457H226.464ZM222.902 165.259L221.811 162.939L220.72 165.259H222.895H222.902Z"
                    fill="#781615"
                />
                <path
                    d="M249.79 172.811V165.107L245.268 170.665H244.322L239.821 165.114V172.811H233.211V156.029H240.132L244.929 162.259L249.762 156.029H256.531V172.811H249.79Z"
                    fill="#781615"
                />
                <path
                    d="M258.234 172.811V156.029H276.338V161.327H264.924V161.84H274.229V166.827H264.924V167.513H276.584V172.811H258.234Z"
                    fill="#781615"
                />
                <path
                    d="M131.978 172.768L124.075 164.637V172.768H117.465V155.986H124.169L131.082 163.243V155.986H137.707V172.768H131.978Z"
                    fill="#781615"
                />
                <path
                    d="M139.41 172.768V155.986H157.514V161.284H146.107V161.797H155.405V166.784H146.107V167.471H157.76V172.768H139.41Z"
                    fill="#781615"
                />
                <path
                    d="M174.615 172.768L171.993 164.565L169.349 172.768H163.064L156.938 155.986H163.88L166.372 164.16L169.103 155.986H174.955L177.678 164.16L180.171 155.986H187.034L180.9 172.768H174.615Z"
                    fill="#781615"
                />
                <path
                    d="M202.14 173.275C195.132 173.275 190.949 169.95 190.949 164.385C190.949 158.82 195.132 155.488 202.14 155.488C205.701 155.488 208.822 156.529 210.931 158.408L211.589 158.994L207.204 162.253H211.719V169.596L211.538 169.798C209.588 172.032 206.25 173.267 202.132 173.267L202.14 173.275ZM202.313 160.938C199.329 160.938 197.819 162.094 197.819 164.385C197.819 167.283 200.29 167.898 202.356 167.898C203.592 167.898 204.523 167.695 205.333 167.247V167.103H200.868V162.268H206.221C205.008 161.306 203.938 160.945 202.313 160.945V160.938Z"
                    fill="#781615"
                />
                <path
                    d="M226.421 172.769L225.164 170.116H218.38L217.123 172.769H209.906L218.445 155.994H225.157L233.696 172.769H226.414H226.421ZM222.866 165.216L221.776 162.896L220.685 165.216H222.859H222.866Z"
                    fill="#781615"
                />
                <path
                    d="M249.748 172.768V165.064L245.225 170.622H244.279L239.778 165.071V172.768H233.168V155.986H240.089L244.886 162.216L249.719 155.986H256.488V172.768H249.748Z"
                    fill="#781615"
                />
                <path
                    d="M258.191 172.768V155.986H276.295V161.284H264.881V161.797H274.186V166.784H264.881V167.471H276.541V172.768H258.191Z"
                    fill="#781615"
                />
                <path
                    d="M131.935 172.723L124.032 164.593V172.723H117.422V155.941H124.126L131.039 163.198V155.941H137.664V172.723H131.935Z"
                    fill="#781615"
                />
                <path
                    d="M139.367 172.723V155.941H157.478V161.239H146.064V161.752H155.362V166.739H146.064V167.426H157.717V172.723H139.367Z"
                    fill="#781615"
                />
                <path
                    d="M174.572 172.723L171.95 164.52L169.306 172.723H163.021L156.895 155.941H163.837L166.329 164.115L169.06 155.941H174.912L177.635 164.115L180.128 155.941H186.991L180.857 172.723H174.572Z"
                    fill="#781615"
                />
                <path
                    d="M202.097 173.23C195.089 173.23 190.906 169.905 190.906 164.34C190.906 158.775 195.089 155.443 202.097 155.443C205.658 155.443 208.779 156.484 210.888 158.363L211.546 158.949L207.161 162.208H211.676V169.551L211.495 169.753C209.545 171.987 206.207 173.223 202.089 173.223L202.097 173.23ZM202.27 160.893C199.286 160.893 197.776 162.049 197.776 164.34C197.776 167.238 200.247 167.853 202.313 167.853C203.549 167.853 204.481 167.65 205.29 167.202V167.058H200.825V162.223H206.178C204.965 161.261 203.895 160.9 202.27 160.9V160.893Z"
                    fill="#781615"
                />
                <path
                    d="M226.378 172.724L225.121 170.071H218.337L217.08 172.724H209.863L218.402 155.949H225.114L233.653 172.724H226.371H226.378ZM222.823 165.171L221.733 162.851L220.642 165.171H222.816H222.823Z"
                    fill="#781615"
                />
                <path
                    d="M249.705 172.723V165.019L245.182 170.577H244.236L239.735 165.026V172.723H233.125V155.941H240.046L244.843 162.171L249.676 155.941H256.445V172.723H249.705Z"
                    fill="#781615"
                />
                <path
                    d="M258.148 172.723V155.941H276.252V161.239H264.838V161.752H274.143V166.739H264.838V167.426H276.498V172.723H258.148Z"
                    fill="#781615"
                />
                <path
                    d="M131.892 172.68L123.989 164.55V172.68H117.379V155.898H124.083L130.997 163.155V155.898H137.621V172.68H131.892Z"
                    fill="#781615"
                />
                <path
                    d="M139.324 172.68V155.898H157.435V161.196H146.021V161.709H155.319V166.696H146.021V167.383H157.674V172.68H139.324Z"
                    fill="#781615"
                />
                <path
                    d="M174.529 172.68L171.907 164.477L169.263 172.68H162.985L156.852 155.898H163.794L166.286 164.073L169.017 155.898H174.869L177.592 164.073L180.085 155.898H186.948L180.814 172.68H174.529Z"
                    fill="#781615"
                />
                <path
                    d="M202.054 173.187C195.046 173.187 190.863 169.862 190.863 164.297C190.863 158.732 195.046 155.4 202.054 155.4C205.615 155.4 208.736 156.441 210.845 158.32L211.503 158.906L207.118 162.165H211.633V169.508L211.452 169.71C209.502 171.944 206.164 173.18 202.046 173.18L202.054 173.187ZM202.227 160.85C199.243 160.85 197.733 162.006 197.733 164.297C197.733 167.195 200.204 167.81 202.27 167.81C203.506 167.81 204.438 167.607 205.247 167.159V167.015H200.782V162.18H206.135C204.922 161.218 203.852 160.857 202.227 160.857V160.85Z"
                    fill="#781615"
                />
                <path
                    d="M226.335 172.681L225.078 170.028H218.294L217.037 172.681H209.82L218.359 155.906H225.071L233.61 172.681H226.328H226.335ZM222.781 165.128L221.69 162.808L220.599 165.128H222.773H222.781Z"
                    fill="#781615"
                />
                <path
                    d="M249.669 172.68V164.976L245.139 170.534H244.193L239.692 164.983V172.68H233.082V155.898H240.01L244.8 162.128L249.64 155.898H256.402V172.68H249.669Z"
                    fill="#781615"
                />
                <path
                    d="M258.105 172.68V155.898H276.209V161.196H264.795V161.709H274.1V166.696H264.795V167.383H276.455V172.68H258.105Z"
                    fill="#781615"
                />
                <path
                    d="M131.849 172.638L123.946 164.507V172.638H117.336V155.863H124.04L130.954 163.112V155.863H137.578V172.638H131.849Z"
                    fill="#781615"
                />
                <path
                    d="M139.281 172.638V155.863H157.392V161.154H145.978V161.667H155.276V166.654H145.978V167.34H157.631V172.638H139.281Z"
                    fill="#781615"
                />
                <path
                    d="M174.486 172.638L171.864 164.435L169.22 172.638H162.942L156.809 155.863H163.758L166.243 164.03L168.974 155.863H174.826L177.549 164.03L180.042 155.863H186.905L180.771 172.638H174.486Z"
                    fill="#781615"
                />
                <path
                    d="M202.011 173.144C195.003 173.144 190.82 169.819 190.82 164.254C190.82 158.689 195.003 155.357 202.011 155.357C205.572 155.357 208.693 156.398 210.802 158.277L211.46 158.863L207.075 162.122H211.59V169.465L211.409 169.667C209.459 171.901 206.121 173.137 202.003 173.137L202.011 173.144ZM202.184 160.807C199.2 160.807 197.691 161.963 197.691 164.254C197.691 167.152 200.161 167.767 202.227 167.767C203.463 167.767 204.395 167.564 205.204 167.116V166.972H200.739V162.137H206.092C204.879 161.175 203.809 160.814 202.184 160.814V160.807Z"
                    fill="#781615"
                />
                <path
                    d="M226.292 172.638L225.035 169.985H218.251L216.994 172.638H209.777L218.316 155.863H225.028L233.567 172.638H226.285H226.292ZM222.738 165.085L221.647 162.765L220.556 165.085H222.73H222.738Z"
                    fill="#781615"
                />
                <path
                    d="M249.626 172.638V164.934L245.096 170.491H244.15L239.649 164.941V172.638H233.039V155.863H239.967L244.757 162.086L249.597 155.863H256.359V172.638H249.626Z"
                    fill="#781615"
                />
                <path
                    d="M258.062 172.638V155.863H276.166V161.154H264.752V161.667H274.057V166.654H264.752V167.34H276.412V172.638H258.062Z"
                    fill="#781615"
                />
                <path
                    d="M131.802 172.595L123.899 164.464V172.595H117.289V155.82H123.993L130.907 163.069V155.82H137.531V172.595H131.802Z"
                    fill="#781615"
                />
                <path
                    d="M139.234 172.595V155.82H157.345V161.111H145.931V161.624H155.229V166.611H145.931V167.297H157.584V172.595H139.234Z"
                    fill="#781615"
                />
                <path
                    d="M174.439 172.595L171.817 164.392L169.173 172.595H162.895L156.762 155.82H163.711L166.197 163.987L168.927 155.82H174.779L177.502 163.987L179.995 155.82H186.858L180.724 172.595H174.439Z"
                    fill="#781615"
                />
                <path
                    d="M201.964 173.101C194.956 173.101 190.773 169.776 190.773 164.211C190.773 158.646 194.956 155.314 201.964 155.314C205.525 155.314 208.646 156.355 210.756 158.234L211.413 158.82L207.028 162.079H211.543V169.422L211.362 169.625C209.412 171.858 206.074 173.094 201.957 173.094L201.964 173.101ZM202.137 160.764C199.154 160.764 197.644 161.92 197.644 164.211C197.644 167.109 200.114 167.724 202.18 167.724C203.416 167.724 204.348 167.521 205.157 167.073V166.929H200.692V162.094H206.045C204.832 161.132 203.763 160.771 202.137 160.771V160.764Z"
                    fill="#781615"
                />
                <path
                    d="M226.245 172.595L224.988 169.942H218.204L216.947 172.595H209.73L218.269 155.82H224.981L233.52 172.595H226.238H226.245ZM222.691 165.042L221.6 162.722L220.509 165.042H222.683H222.691Z"
                    fill="#781615"
                />
                <path
                    d="M249.579 172.595V164.891L245.049 170.448H244.103L239.602 164.898V172.595H232.992V155.82H239.92L244.71 162.043L249.55 155.82H256.312V172.595H249.579Z"
                    fill="#781615"
                />
                <path
                    d="M258.016 172.595V155.82H276.119V161.111H264.712V161.624H274.01V166.611H264.712V167.297H276.365V172.595H258.016Z"
                    fill="#781615"
                />
                <path
                    d="M131.76 172.552L123.856 164.421V172.552H117.246V155.777H123.95L130.864 163.026V155.777H137.488V172.552H131.76Z"
                    fill="#781615"
                />
                <path
                    d="M139.191 172.552V155.777H157.302V161.068H145.888V161.581H155.186V166.568H145.888V167.254H157.541V172.552H139.191Z"
                    fill="#781615"
                />
                <path
                    d="M174.396 172.552L171.774 164.349L169.13 172.552H162.852L156.719 155.777H163.668L166.154 163.944L168.884 155.777H174.736L177.459 163.944L179.952 155.777H186.815L180.681 172.552H174.396Z"
                    fill="#781615"
                />
                <path
                    d="M201.921 173.058C194.913 173.058 190.73 169.733 190.73 164.168C190.73 158.603 194.913 155.271 201.921 155.271C205.482 155.271 208.603 156.312 210.713 158.191L211.37 158.777L206.985 162.036H211.5V169.379L211.319 169.582C209.369 171.815 206.031 173.051 201.914 173.051L201.921 173.058ZM202.094 160.721C199.111 160.721 197.601 161.877 197.601 164.168C197.601 167.066 200.071 167.681 202.137 167.681C203.373 167.681 204.305 167.478 205.114 167.03V166.886H200.649V162.051H206.002C204.789 161.089 203.72 160.728 202.094 160.728V160.721Z"
                    fill="#781615"
                />
                <path
                    d="M226.202 172.552L224.945 169.9H218.161L216.904 172.552H209.688L218.227 155.777H224.938L233.477 172.552H226.195H226.202ZM222.648 164.999L221.557 162.679L220.466 164.999H222.641H222.648Z"
                    fill="#781615"
                />
                <path
                    d="M249.536 172.552V164.848L245.006 170.405H244.06L239.559 164.855V172.552H232.949V155.777H239.877L244.667 162L249.507 155.777H256.269V172.552H249.536Z"
                    fill="#781615"
                />
                <path
                    d="M257.973 172.552V155.777H276.084V161.068H264.67V161.581H273.967V166.568H264.67V167.254H276.322V172.552H257.973Z"
                    fill="#781615"
                />
                <path
                    d="M131.717 172.507L123.814 164.376V172.507H117.211V155.732H123.908L130.821 162.981V155.732H137.446V172.507H131.717Z"
                    fill="#781615"
                />
                <path
                    d="M139.152 172.507V155.732H157.263V161.023H145.849V161.536H155.147V166.523H145.849V167.209H157.502V172.507H139.152Z"
                    fill="#781615"
                />
                <path
                    d="M174.353 172.507L171.731 164.304L169.087 172.507H162.809L156.676 155.732H163.625L166.111 163.899L168.841 155.732H174.693L177.416 163.899L179.909 155.732H186.772L180.638 172.507H174.353Z"
                    fill="#781615"
                />
                <path
                    d="M201.878 173.013C194.87 173.013 190.688 169.688 190.688 164.123C190.688 158.558 194.87 155.227 201.878 155.227C205.439 155.227 208.56 156.267 210.67 158.146L211.327 158.732L206.942 161.991H211.457V169.334L211.276 169.537C209.326 171.77 205.988 173.006 201.871 173.006L201.878 173.013ZM202.051 160.676C199.068 160.676 197.558 161.832 197.558 164.123C197.558 167.022 200.028 167.636 202.095 167.636C203.33 167.636 204.262 167.433 205.071 166.985V166.841H200.606V162.006H205.959C204.746 161.045 203.677 160.683 202.051 160.683V160.676Z"
                    fill="#781615"
                />
                <path
                    d="M226.159 172.507L224.902 169.855H218.119L216.862 172.507H209.645L218.184 155.732H224.895L233.434 172.507H226.152H226.159ZM222.605 164.954L221.514 162.635L220.423 164.954H222.598H222.605Z"
                    fill="#781615"
                />
                <path
                    d="M249.493 172.507V164.803L244.963 170.361H244.017L239.516 164.81V172.507H232.906V155.732H239.834L244.624 161.955L249.464 155.732H256.226V172.507H249.493Z"
                    fill="#781615"
                />
                <path
                    d="M257.93 172.507V155.732H276.041V161.023H264.627V161.536H273.924V166.523H264.627V167.209H276.279V172.507H257.93Z"
                    fill="#781615"
                />
                <path
                    d="M131.674 172.464L123.771 164.333V172.464H117.168V155.689H123.865L130.778 162.938V155.689H137.403V172.464H131.674Z"
                    fill="#781615"
                />
                <path
                    d="M139.109 172.464V155.689H157.22V160.98H145.806V161.493H155.104V166.48H145.806V167.166H157.459V172.464H139.109Z"
                    fill="#781615"
                />
                <path
                    d="M174.31 172.464L171.688 164.261L169.044 172.464H162.766L156.633 155.689H163.582L166.068 163.856L168.798 155.689H174.65L177.373 163.856L179.866 155.689H186.729L180.595 172.464H174.31Z"
                    fill="#781615"
                />
                <path
                    d="M201.835 172.97C194.827 172.97 190.645 169.645 190.645 164.08C190.645 158.515 194.827 155.184 201.835 155.184C205.396 155.184 208.517 156.224 210.627 158.103L211.284 158.689L206.899 161.948H211.414V169.291L211.233 169.494C209.283 171.727 205.945 172.963 201.828 172.963L201.835 172.97ZM202.008 160.633C199.025 160.633 197.515 161.789 197.515 164.08C197.515 166.979 199.985 167.593 202.052 167.593C203.287 167.593 204.219 167.391 205.028 166.942V166.798H200.563V161.963H205.916C204.703 161.002 203.634 160.64 202.008 160.64V160.633Z"
                    fill="#781615"
                />
                <path
                    d="M226.116 172.464L224.859 169.812H218.076L216.819 172.464H209.602L218.141 155.689H224.852L233.391 172.464H226.109H226.116ZM222.562 164.912L221.471 162.592L220.38 164.912H222.555H222.562Z"
                    fill="#781615"
                />
                <path
                    d="M249.45 172.464V164.76L244.92 170.318H243.974L239.473 164.767V172.464H232.863V155.689H239.791L244.581 161.912L249.421 155.689H256.183V172.464H249.45Z"
                    fill="#781615"
                />
                <path
                    d="M257.887 172.464V155.689H275.998V160.98H264.584V161.493H273.881V166.48H264.584V167.166H276.236V172.464H257.887Z"
                    fill="#781615"
                />
                <path
                    d="M131.631 172.421L123.728 164.29V172.421H117.125V155.646H123.822L130.735 162.895V155.646H137.36V172.421H131.631Z"
                    fill="#781615"
                />
                <path
                    d="M139.066 172.421V155.646H157.177V160.937H145.763V161.45H155.061V166.437H145.763V167.123H157.416V172.421H139.066Z"
                    fill="#781615"
                />
                <path
                    d="M174.267 172.421L171.645 164.218L169.001 172.421H162.723L156.59 155.646H163.54L166.025 163.813L168.755 155.646H174.607L177.331 163.813L179.823 155.646H186.686L180.553 172.421H174.267Z"
                    fill="#781615"
                />
                <path
                    d="M201.792 172.927C194.784 172.927 190.602 169.602 190.602 164.037C190.602 158.472 194.784 155.141 201.792 155.141C205.353 155.141 208.474 156.181 210.584 158.06L211.241 158.646L206.856 161.905H211.371V169.248L211.191 169.451C209.24 171.684 205.902 172.92 201.785 172.92L201.792 172.927ZM201.965 160.59C198.982 160.59 197.472 161.746 197.472 164.037C197.472 166.936 199.942 167.55 202.009 167.55C203.244 167.55 204.176 167.348 204.985 166.899V166.755H200.52V161.92H205.874C204.66 160.959 203.591 160.597 201.965 160.597V160.59Z"
                    fill="#781615"
                />
                <path
                    d="M226.073 172.421L224.816 169.769H218.033L216.776 172.421H209.559L218.098 155.646H224.809L233.348 172.421H226.066H226.073ZM222.519 164.869L221.428 162.549L220.337 164.869H222.512H222.519Z"
                    fill="#781615"
                />
                <path
                    d="M249.407 172.421V164.717L244.877 170.275H243.931L239.43 164.724V172.421H232.82V155.646H239.748L244.538 161.869L249.378 155.646H256.14V172.421H249.407Z"
                    fill="#781615"
                />
                <path
                    d="M257.844 172.421V155.646H275.955V160.937H264.541V161.45H273.838V166.437H264.541V167.123H276.193V172.421H257.844Z"
                    fill="#781615"
                />
                <path
                    d="M131.588 172.378L123.685 164.247V172.378H117.082V155.604H123.779L130.692 162.853V155.604H137.317V172.378H131.588Z"
                    fill="#781615"
                />
                <path
                    d="M139.023 172.378V155.604H157.135V160.894H145.72V161.407H155.018V166.394H145.72V167.08H157.373V172.378H139.023Z"
                    fill="#781615"
                />
                <path
                    d="M174.224 172.378L171.602 164.175L168.958 172.378H162.68L156.547 155.604H163.497L165.982 163.77L168.712 155.604H174.564L177.288 163.77L179.78 155.604H186.643L180.51 172.378H174.224Z"
                    fill="#781615"
                />
                <path
                    d="M201.749 172.884C194.741 172.884 190.559 169.56 190.559 163.994C190.559 158.429 194.741 155.098 201.749 155.098C205.31 155.098 208.431 156.138 210.541 158.017L211.198 158.603L206.813 161.862H211.328V169.205L211.148 169.408C209.197 171.641 205.859 172.877 201.742 172.877L201.749 172.884ZM201.922 160.547C198.939 160.547 197.429 161.703 197.429 163.994C197.429 166.893 199.899 167.507 201.966 167.507C203.201 167.507 204.133 167.305 204.942 166.856V166.712H200.477V161.877H205.831C204.617 160.916 203.548 160.554 201.922 160.554V160.547Z"
                    fill="#781615"
                />
                <path
                    d="M226.03 172.378L224.773 169.726H217.99L216.733 172.378H209.516L218.055 155.604H224.766L233.305 172.378H226.023H226.03ZM222.476 164.826L221.385 162.506L220.294 164.826H222.469H222.476Z"
                    fill="#781615"
                />
                <path
                    d="M249.364 172.378V164.674L244.835 170.232H243.888L239.387 164.681V172.378H232.777V155.604H239.705L244.495 161.826L249.335 155.604H256.097V172.378H249.364Z"
                    fill="#781615"
                />
                <path
                    d="M257.801 172.378V155.604H275.912V160.894H264.498V161.407H273.795V166.394H264.498V167.08H276.15V172.378H257.801Z"
                    fill="#781615"
                />
                <path
                    d="M131.545 172.335L123.642 164.204V172.335H117.039V155.561H123.736L130.649 162.81V155.561H137.274V172.335H131.545Z"
                    fill="#781615"
                />
                <path
                    d="M138.98 172.335V155.561H157.092V160.858H145.677V161.364H154.975V166.351H145.677V167.038H157.33V172.335H138.98Z"
                    fill="#781615"
                />
                <path
                    d="M174.182 172.335L171.559 164.132L168.915 172.335H162.637L156.504 155.561H163.454L165.939 163.727L168.669 155.561H174.521L177.245 163.727L179.737 155.561H186.6L180.467 172.335H174.182Z"
                    fill="#781615"
                />
                <path
                    d="M201.706 172.841C194.698 172.841 190.516 169.517 190.516 163.952C190.516 158.386 194.698 155.055 201.706 155.055C205.267 155.055 208.388 156.095 210.498 157.975L211.155 158.56L206.77 161.819H211.285V169.162L211.105 169.365C209.154 171.598 205.816 172.834 201.699 172.834L201.706 172.841ZM201.879 160.504C198.896 160.504 197.386 161.66 197.386 163.952C197.386 166.85 199.856 167.464 201.923 167.464C203.158 167.464 204.09 167.262 204.899 166.814V166.669H200.434V161.834H205.788C204.574 160.873 203.505 160.511 201.879 160.511V160.504Z"
                    fill="#781615"
                />
                <path
                    d="M225.987 172.335L224.73 169.683H217.947L216.69 172.335H209.473L218.012 155.561H224.723L233.262 172.335H225.98H225.987ZM222.433 164.783L221.342 162.463L220.251 164.783H222.426H222.433Z"
                    fill="#781615"
                />
                <path
                    d="M249.321 172.335V164.631L244.792 170.189H243.845L239.345 164.638V172.335H232.734V155.561H239.662L244.452 161.783L249.292 155.561H256.054V172.335H249.321Z"
                    fill="#781615"
                />
                <path
                    d="M257.758 172.335V155.561H275.869V160.858H264.455V161.364H273.752V166.351H264.455V167.038H276.107V172.335H257.758Z"
                    fill="#781615"
                />
                <path
                    d="M131.51 172.29L123.599 164.159V172.29H116.996V155.516H123.693L130.606 162.765V155.516H137.231V172.29H131.51Z"
                    fill="#781615"
                />
                <path
                    d="M138.938 172.29V155.516H157.049V160.813H145.634V161.319H154.932V166.306H145.634V166.993H157.287V172.29H138.938Z"
                    fill="#781615"
                />
                <path
                    d="M174.139 172.29L171.516 164.087L168.872 172.29H162.594L156.461 155.516H163.411L165.896 163.682L168.626 155.516H174.478L177.202 163.682L179.694 155.516H186.557L180.424 172.29H174.139Z"
                    fill="#781615"
                />
                <path
                    d="M201.663 172.796C194.655 172.796 190.473 169.472 190.473 163.907C190.473 158.342 194.655 155.01 201.663 155.01C205.224 155.01 208.345 156.051 210.455 157.93L211.112 158.515L206.727 161.775H211.242V169.117L211.062 169.32C209.111 171.553 205.773 172.789 201.656 172.789L201.663 172.796ZM201.836 160.459C198.853 160.459 197.343 161.616 197.343 163.907C197.343 166.805 199.814 167.419 201.88 167.419C203.115 167.419 204.047 167.217 204.856 166.769V166.624H200.391V161.789H205.745C204.531 160.828 203.462 160.466 201.836 160.466V160.459Z"
                    fill="#781615"
                />
                <path
                    d="M225.944 172.29L224.687 169.638H217.904L216.647 172.29H209.43L217.969 155.516H224.68L233.219 172.29H225.937H225.944ZM222.39 164.738L221.299 162.418L220.208 164.738H222.383H222.39Z"
                    fill="#781615"
                />
                <path
                    d="M249.278 172.29V164.586L244.749 170.144H243.802L239.302 164.593V172.29H232.691V155.516H239.619L244.409 161.738L249.249 155.516H256.011V172.29H249.278Z"
                    fill="#781615"
                />
                <path
                    d="M257.715 172.29V155.516H275.826V160.813H264.412V161.319H273.709V166.306H264.412V166.993H276.064V172.29H257.715Z"
                    fill="#781615"
                />
                <path
                    d="M131.467 172.247L123.556 164.117V172.247H116.953V155.473H123.65L130.564 162.722V155.473H137.188V172.247H131.467Z"
                    fill="#781615"
                />
                <path
                    d="M138.895 172.247V155.473H157.006V160.77H145.591V161.276H154.896V166.27H145.591V166.957H157.244V172.247H138.895Z"
                    fill="#781615"
                />
                <path
                    d="M174.096 172.247L171.473 164.044L168.829 172.247H162.551L156.418 155.473H163.368L165.853 163.64L168.584 155.473H174.435L177.166 163.64L179.651 155.473H186.514L180.381 172.247H174.096Z"
                    fill="#781615"
                />
                <path
                    d="M201.62 172.753C194.613 172.753 190.43 169.429 190.43 163.864C190.43 158.299 194.613 154.967 201.62 154.967C205.182 154.967 208.302 156.008 210.412 157.887L211.069 158.472L206.684 161.732H211.199V169.075L211.019 169.277C209.068 171.51 205.731 172.746 201.613 172.746L201.62 172.753ZM201.793 160.416C198.81 160.416 197.3 161.573 197.3 163.864C197.3 166.762 199.771 167.376 201.837 167.376C203.072 167.376 204.004 167.174 204.813 166.726V166.581H200.349V161.746H205.702C204.488 160.785 203.419 160.423 201.793 160.423V160.416Z"
                    fill="#781615"
                />
                <path
                    d="M225.901 172.247L224.644 169.595H217.861L216.604 172.247H209.387L217.926 155.473H224.637L233.176 172.247H225.894H225.901ZM222.347 164.695L221.256 162.375L220.165 164.695H222.34H222.347Z"
                    fill="#781615"
                />
                <path
                    d="M249.235 172.247V164.543L244.706 170.101H243.759L239.259 164.55V172.247H232.648V155.473H239.576L244.366 161.695L249.206 155.473H255.968V172.247H249.235Z"
                    fill="#781615"
                />
                <path
                    d="M257.672 172.247V155.473H275.783V160.77H264.369V161.276H273.666V166.27H264.369V166.957H276.021V172.247H257.672Z"
                    fill="#781615"
                />
                <path
                    d="M131.42 172.204L123.509 164.074V172.204H116.906V155.43H123.603L130.517 162.679V155.43H137.141V172.204H131.42Z"
                    fill="#781615"
                />
                <path
                    d="M138.848 172.204V155.43H156.959V160.727H145.544V161.233H154.849V166.227H145.544V166.914H157.197V172.204H138.848Z"
                    fill="#781615"
                />
                <path
                    d="M174.049 172.204L171.426 164.001L168.789 172.204H162.504L156.371 155.43H163.321L165.806 163.597L168.537 155.43H174.388L177.119 163.597L179.604 155.43H186.467L180.334 172.204H174.049Z"
                    fill="#781615"
                />
                <path
                    d="M201.573 172.71C194.566 172.71 190.383 169.386 190.383 163.821C190.383 158.256 194.566 154.924 201.573 154.924C205.135 154.924 208.255 155.965 210.365 157.844L211.022 158.429L206.637 161.689H211.152V169.032L210.972 169.234C209.021 171.467 205.684 172.703 201.566 172.703L201.573 172.71ZM201.754 160.373C198.77 160.373 197.26 161.53 197.26 163.821C197.26 166.719 199.731 167.333 201.797 167.333C203.032 167.333 203.964 167.131 204.773 166.683V166.538H200.309V161.703H205.662C204.448 160.742 203.379 160.38 201.754 160.38V160.373Z"
                    fill="#781615"
                />
                <path
                    d="M225.854 172.204L224.597 169.552H217.814L216.557 172.204H209.34L217.879 155.43H224.59L233.129 172.204H225.847H225.854ZM222.3 164.652L221.209 162.332L220.118 164.652H222.293H222.3Z"
                    fill="#781615"
                />
                <path
                    d="M249.189 172.204V164.5L244.659 170.058H243.713L239.212 164.507V172.204H232.609V155.43H239.53L244.32 161.652L249.16 155.43H255.922V172.204H249.189Z"
                    fill="#781615"
                />
                <path
                    d="M257.625 172.204V155.43H275.736V160.727H264.322V161.233H273.619V166.227H264.322V166.914H275.974V172.204H257.625Z"
                    fill="#781615"
                />
                <path
                    d="M131.377 172.161L123.466 164.031V172.161H116.863V155.387H123.56L130.474 162.636V155.387H137.098V172.161H131.377Z"
                    fill="#781615"
                />
                <path
                    d="M138.805 172.161V155.387H156.916V160.684H145.502V161.19H154.806V166.184H145.502V166.871H157.154V172.161H138.805Z"
                    fill="#781615"
                />
                <path
                    d="M174.006 172.161L171.383 163.958L168.747 172.161H162.461L156.328 155.387H163.278L165.763 163.554L168.494 155.387H174.345L177.076 163.554L179.561 155.387H186.424L180.291 172.161H174.006Z"
                    fill="#781615"
                />
                <path
                    d="M201.53 172.667C194.523 172.667 190.34 169.343 190.34 163.778C190.34 158.213 194.523 154.881 201.53 154.881C205.092 154.881 208.213 155.922 210.322 157.801L210.979 158.386L206.594 161.646H211.109V168.989L210.929 169.191C208.978 171.424 205.641 172.66 201.523 172.66L201.53 172.667ZM201.711 160.33C198.727 160.33 197.217 161.487 197.217 163.778C197.217 166.676 199.688 167.29 201.754 167.29C202.989 167.29 203.921 167.088 204.73 166.64V166.495H200.266V161.66H205.619C204.405 160.699 203.336 160.337 201.711 160.337V160.33Z"
                    fill="#781615"
                />
                <path
                    d="M225.811 172.161L224.554 169.509H217.771L216.514 172.161H209.297L217.836 155.387H224.547L233.086 172.161H225.804H225.811ZM222.257 164.609L221.166 162.289L220.075 164.609H222.25H222.257Z"
                    fill="#781615"
                />
                <path
                    d="M249.146 172.161V164.457L244.616 170.015H243.67L239.169 164.464V172.161H232.566V155.387H239.487L244.277 161.609L249.117 155.387H255.879V172.161H249.146Z"
                    fill="#781615"
                />
                <path
                    d="M257.582 172.161V155.387H275.693V160.684H264.279V161.19H273.576V166.184H264.279V166.871H275.931V172.161H257.582Z"
                    fill="#781615"
                />
                <path
                    d="M131.334 172.118L123.423 163.995V172.118H116.82V155.344H123.517L130.431 162.593V155.344H137.055V172.118H131.334Z"
                    fill="#781615"
                />
                <path
                    d="M138.762 172.118V155.344H156.873V160.641H145.459V161.147H154.763V166.141H145.459V166.828H157.111V172.118H138.762Z"
                    fill="#781615"
                />
                <path
                    d="M173.963 172.118L171.34 163.915L168.704 172.118H162.418L156.285 155.344H163.235L165.72 163.511L168.451 155.344H174.302L177.033 163.511L179.518 155.344H186.381L180.248 172.118H173.963Z"
                    fill="#781615"
                />
                <path
                    d="M201.487 172.624C194.48 172.624 190.297 169.3 190.297 163.735C190.297 158.17 194.48 154.838 201.487 154.838C205.049 154.838 208.17 155.879 210.279 157.758L210.936 158.343L206.551 161.603H211.066V168.946L210.886 169.148C208.935 171.381 205.598 172.617 201.48 172.617L201.487 172.624ZM201.668 160.287C198.684 160.287 197.174 161.444 197.174 163.735C197.174 166.633 199.645 167.247 201.711 167.247C202.946 167.247 203.878 167.045 204.687 166.597V166.452H200.223V161.617H205.576C204.362 160.656 203.293 160.295 201.668 160.295V160.287Z"
                    fill="#781615"
                />
                <path
                    d="M225.768 172.118L224.511 169.466H217.728L216.471 172.118H209.254L217.793 155.344H224.504L233.043 172.118H225.761H225.768ZM222.214 164.566L221.123 162.246L220.032 164.566H222.207H222.214Z"
                    fill="#781615"
                />
                <path
                    d="M249.103 172.118V164.414L244.573 169.972H243.627L239.126 164.421V172.118H232.523V155.344H239.444L244.234 161.574L249.074 155.344H255.836V172.118H249.103Z"
                    fill="#781615"
                />
                <path
                    d="M257.539 172.118V155.344H275.65V160.641H264.236V161.147H273.533V166.141H264.236V166.828H275.889V172.118H257.539Z"
                    fill="#781615"
                />
                <path
                    d="M131.291 172.073L123.38 163.95V172.073H116.777V155.299H123.474L130.388 162.548V155.299H137.02V172.073H131.291Z"
                    fill="#781615"
                />
                <path
                    d="M138.719 172.073V155.299H156.83V160.596H145.416V161.102H154.72V166.096H145.416V166.783H157.068V172.073H138.719Z"
                    fill="#781615"
                />
                <path
                    d="M173.92 172.073L171.297 163.87L168.661 172.073H162.376L156.242 155.299H163.192L165.677 163.466L168.408 155.299H174.259L176.99 163.466L179.475 155.299H186.338L180.205 172.073H173.92Z"
                    fill="#781615"
                />
                <path
                    d="M201.444 172.579C194.437 172.579 190.254 169.255 190.254 163.69C190.254 158.125 194.437 154.793 201.444 154.793C205.006 154.793 208.127 155.834 210.236 157.713L210.893 158.298L206.508 161.558H211.023V168.901L210.843 169.103C208.892 171.336 205.555 172.572 201.437 172.572L201.444 172.579ZM201.625 160.242C198.641 160.242 197.131 161.399 197.131 163.69C197.131 166.588 199.602 167.202 201.668 167.202C202.903 167.202 203.835 167 204.645 166.552V166.407H200.18V161.572H205.533C204.319 160.611 203.25 160.25 201.625 160.25V160.242Z"
                    fill="#781615"
                />
                <path
                    d="M225.733 172.073L224.476 169.421H217.693L216.436 172.073H209.219L217.758 155.299H224.469L233.008 172.073H225.726H225.733ZM222.172 164.521L221.081 162.201L219.99 164.521H222.165H222.172Z"
                    fill="#781615"
                />
                <path
                    d="M249.06 172.073V164.369L244.53 169.927H243.584L239.083 164.376V172.073H232.48V155.299H239.401L244.191 161.529L249.031 155.299H255.8V172.073H249.06Z"
                    fill="#781615"
                />
                <path
                    d="M257.496 172.073V155.299H275.607V160.596H264.193V161.102H273.498V166.096H264.193V166.783H275.846V172.073H257.496Z"
                    fill="#781615"
                />
                <path
                    d="M131.248 172.03L123.337 163.907V172.03H116.734V155.256H123.431L130.345 162.505V155.256H136.977V172.03H131.248Z"
                    fill="#781615"
                />
                <path
                    d="M138.676 172.03V155.256H156.787V160.553H145.373V161.059H154.677V166.053H145.373V166.74H157.025V172.03H138.676Z"
                    fill="#781615"
                />
                <path
                    d="M173.877 172.03L171.254 163.827L168.618 172.03H162.333L156.199 155.256H163.149L165.634 163.423L168.365 155.256H174.216L176.947 163.423L179.432 155.256H186.295L180.162 172.03H173.877Z"
                    fill="#781615"
                />
                <path
                    d="M201.401 172.536C194.394 172.536 190.211 169.212 190.211 163.647C190.211 158.082 194.394 154.75 201.401 154.75C204.963 154.75 208.084 155.791 210.193 157.67L210.85 158.255L206.465 161.515H210.981V168.858L210.8 169.06C208.849 171.293 205.512 172.529 201.394 172.529L201.401 172.536ZM201.582 160.199C198.598 160.199 197.088 161.356 197.088 163.647C197.088 166.545 199.559 167.159 201.625 167.159C202.86 167.159 203.792 166.957 204.602 166.509V166.364H200.137V161.529H205.49C204.276 160.568 203.207 160.207 201.582 160.207V160.199Z"
                    fill="#781615"
                />
                <path
                    d="M225.69 172.03L224.433 169.378H217.65L216.393 172.03H209.176L217.715 155.256H224.426L232.965 172.03H225.683H225.69ZM222.129 164.478L221.038 162.158L219.947 164.478H222.122H222.129Z"
                    fill="#781615"
                />
                <path
                    d="M249.017 172.03V164.333L244.487 169.884H243.541L239.04 164.333V172.03H232.438V155.256H239.358L244.148 161.486L248.988 155.256H255.757V172.03H249.017Z"
                    fill="#781615"
                />
                <path
                    d="M257.453 172.03V155.256H275.564V160.553H264.15V161.059H273.455V166.053H264.15V166.74H275.803V172.03H257.453Z"
                    fill="#781615"
                />
                <path
                    d="M131.205 171.987L123.294 163.864V171.987H116.691V155.213H123.388L130.302 162.462V155.213H136.934V171.987H131.205Z"
                    fill="#781615"
                />
                <path
                    d="M138.633 171.987V155.213H156.744V160.511H145.33V161.016H154.634V166.01H145.33V166.697H156.982V171.987H138.633Z"
                    fill="#781615"
                />
                <path
                    d="M173.834 171.987L171.211 163.784L168.575 171.987H162.29L156.156 155.213H163.106L165.591 163.38L168.322 155.213H174.173L176.904 163.38L179.389 155.213H186.252L180.119 171.987H173.834Z"
                    fill="#781615"
                />
                <path
                    d="M201.358 172.493C194.351 172.493 190.168 169.169 190.168 163.604C190.168 158.039 194.351 154.707 201.358 154.707C204.92 154.707 208.041 155.748 210.15 157.627L210.808 158.212L206.422 161.472H210.938V168.815L210.757 169.017C208.806 171.25 205.469 172.486 201.351 172.486L201.358 172.493ZM201.539 160.156C198.555 160.156 197.045 161.313 197.045 163.604C197.045 166.502 199.516 167.116 201.582 167.116C202.818 167.116 203.749 166.914 204.559 166.466V166.321H200.094V161.486H205.447C204.233 160.525 203.164 160.164 201.539 160.164V160.156Z"
                    fill="#781615"
                />
                <path
                    d="M225.647 171.987L224.39 169.335H217.607L216.35 171.987H209.133L217.672 155.213H224.383L232.922 171.987H225.64H225.647ZM222.086 164.435L220.995 162.115L219.904 164.435H222.079H222.086Z"
                    fill="#781615"
                />
                <path
                    d="M248.974 171.987V164.29L244.444 169.841H243.498L238.997 164.29V171.987H232.395V155.213H239.315L244.112 161.443L248.945 155.213H255.714V171.987H248.974Z"
                    fill="#781615"
                />
                <path
                    d="M257.41 171.987V155.213H275.521V160.511H264.107V161.016H273.412V166.01H264.107V166.697H275.76V171.987H257.41Z"
                    fill="#781615"
                />
                <path
                    d="M131.162 171.945L123.251 163.821V171.945H116.648V155.17H123.345L130.259 162.419V155.17H136.891V171.945H131.162Z"
                    fill="#781615"
                />
                <path
                    d="M138.59 171.945V155.17H156.701V160.468H145.287V160.973H154.591V165.968H145.287V166.654H156.939V171.945H138.59Z"
                    fill="#781615"
                />
                <path
                    d="M173.791 171.945L171.169 163.742L168.532 171.945H162.247L156.113 155.17H163.063L165.548 163.344L168.279 155.17H174.13L176.861 163.344L179.346 155.17H186.209L180.076 171.945H173.791Z"
                    fill="#781615"
                />
                <path
                    d="M201.315 172.45C194.308 172.45 190.125 169.126 190.125 163.561C190.125 157.996 194.308 154.664 201.315 154.664C204.877 154.664 207.998 155.705 210.107 157.584L210.765 158.169L206.379 161.429H210.895V168.772L210.714 168.974C208.763 171.207 205.426 172.443 201.308 172.443L201.315 172.45ZM201.496 160.113C198.512 160.113 197.002 161.27 197.002 163.561C197.002 166.459 199.473 167.073 201.539 167.073C202.775 167.073 203.706 166.871 204.516 166.423V166.278H200.051V161.443H205.404C204.191 160.482 203.121 160.121 201.496 160.121V160.113Z"
                    fill="#781615"
                />
                <path
                    d="M225.604 171.945L224.347 169.292H217.564L216.307 171.945H209.09L217.629 155.17H224.34L232.879 171.945H225.597H225.604ZM222.043 164.392L220.952 162.072L219.861 164.392H222.036H222.043Z"
                    fill="#781615"
                />
                <path
                    d="M248.931 171.945V164.247L244.409 169.798H243.455L238.954 164.247V171.945H232.352V155.17H239.272L244.069 161.4L248.902 155.17H255.671V171.945H248.931Z"
                    fill="#781615"
                />
                <path
                    d="M257.367 171.945V155.17H275.478V160.468H264.064V160.973H273.369V165.968H264.064V166.654H275.717V171.945H257.367Z"
                    fill="#781615"
                />
                <path
                    d="M131.119 171.902L123.208 163.778V171.902H116.605V155.127H123.302L130.216 162.376V155.127H136.848V171.902H131.119Z"
                    fill="#781615"
                />
                <path
                    d="M138.547 171.902V155.127H156.658V160.425H145.244V160.93H154.548V165.925H145.244V166.611H156.904V171.902H138.547Z"
                    fill="#781615"
                />
                <path
                    d="M173.748 171.902L171.126 163.699L168.489 171.902H162.204L156.07 155.127H163.02L165.512 163.301L168.236 155.127H174.087L176.818 163.301L179.303 155.127H186.166L180.033 171.902H173.748Z"
                    fill="#781615"
                />
                <path
                    d="M201.272 172.408C194.265 172.408 190.082 169.083 190.082 163.518C190.082 157.953 194.265 154.621 201.272 154.621C204.834 154.621 207.955 155.662 210.064 157.541L210.722 158.126L206.336 161.386H210.852V168.729L210.671 168.931C208.72 171.164 205.383 172.4 201.265 172.4L201.272 172.408ZM201.453 160.07C198.469 160.07 196.959 161.227 196.959 163.518C196.959 166.416 199.43 167.03 201.496 167.03C202.732 167.03 203.664 166.828 204.473 166.38V166.235H200.008V161.4H205.361C204.148 160.439 203.078 160.078 201.453 160.078V160.07Z"
                    fill="#781615"
                />
                <path
                    d="M225.561 171.902L224.304 169.249H217.521L216.264 171.902H209.047L217.586 155.127H224.297L232.836 171.902H225.554H225.561ZM222 164.349L220.909 162.029L219.818 164.349H221.993H222Z"
                    fill="#781615"
                />
                <path
                    d="M248.888 171.902V164.204L244.366 169.755H243.412L238.912 164.204V171.902H232.309V155.127H239.229L244.026 161.357L248.859 155.127H255.628V171.902H248.888Z"
                    fill="#781615"
                />
                <path
                    d="M257.324 171.902V155.127H275.435V160.425H264.021V160.93H273.326V165.925H264.021V166.611H275.674V171.902H257.324Z"
                    fill="#781615"
                />
                <path
                    d="M131.076 171.857L123.165 163.733V171.857H116.562V155.082H123.259L130.173 162.331V155.082H136.805V171.857H131.076Z"
                    fill="#781615"
                />
                <path
                    d="M138.504 171.857V155.082H156.615V160.38H145.201V160.893H154.506V165.88H145.201V166.566H156.861V171.857H138.504Z"
                    fill="#781615"
                />
                <path
                    d="M173.705 171.857L171.083 163.654L168.446 171.857H162.161L156.027 155.082H162.977L165.469 163.256L168.193 155.082H174.044L176.775 163.256L179.26 155.082H186.123L179.99 171.857H173.705Z"
                    fill="#781615"
                />
                <path
                    d="M201.229 172.363C194.222 172.363 190.039 169.038 190.039 163.473C190.039 157.908 194.222 154.576 201.229 154.576C204.791 154.576 207.912 155.617 210.021 157.496L210.679 158.081L206.294 161.341H210.809V168.684L210.628 168.886C208.677 171.119 205.34 172.355 201.222 172.355L201.229 172.363ZM201.41 160.026C198.426 160.026 196.916 161.182 196.916 163.473C196.916 166.371 199.387 166.985 201.453 166.985C202.689 166.985 203.621 166.783 204.43 166.335V166.19H199.965V161.355H205.318C204.105 160.394 203.035 160.033 201.41 160.033V160.026Z"
                    fill="#781615"
                />
                <path
                    d="M225.518 171.857L224.261 169.204H217.478L216.221 171.857H209.004L217.543 155.082H224.254L232.793 171.857H225.511H225.518ZM221.957 164.304L220.866 161.984L219.775 164.304H221.95H221.957Z"
                    fill="#781615"
                />
                <path
                    d="M248.845 171.857V164.16L244.323 169.71H243.369L238.869 164.16V171.857H232.266V155.082H239.186L243.983 161.312L248.816 155.082H255.585V171.857H248.845Z"
                    fill="#781615"
                />
                <path
                    d="M257.281 171.857V155.082H275.392V160.38H263.978V160.893H273.283V165.88H263.978V166.566H275.631V171.857H257.281Z"
                    fill="#781615"
                />
                <path
                    d="M131.033 171.821L123.122 163.69V171.821H116.52V155.039H123.216L130.13 162.288V155.039H136.762V171.821H131.033Z"
                    fill="#781615"
                />
                <path
                    d="M138.465 171.821V155.039H156.569V160.337H145.154V160.85H154.459V165.837H145.154V166.523H156.814V171.821H138.465Z"
                    fill="#781615"
                />
                <path
                    d="M173.662 171.821L171.04 163.611L168.403 171.821H162.118L155.984 155.039H162.934L165.426 163.213L168.15 155.039H174.002L176.732 163.213L179.217 155.039H186.08L179.947 171.821H173.662Z"
                    fill="#781615"
                />
                <path
                    d="M201.186 172.32C194.179 172.32 189.996 168.995 189.996 163.43C189.996 157.865 194.179 154.533 201.186 154.533C204.748 154.533 207.869 155.574 209.978 157.453L210.636 158.038L206.251 161.298H210.766V168.641L210.585 168.843C208.635 171.077 205.297 172.312 201.179 172.312L201.186 172.32ZM201.367 159.983C198.383 159.983 196.874 161.139 196.874 163.43C196.874 166.328 199.344 166.943 201.41 166.943C202.646 166.943 203.578 166.74 204.387 166.292V166.147H199.922V161.312H205.275C204.062 160.351 202.992 159.99 201.367 159.99V159.983Z"
                    fill="#781615"
                />
                <path
                    d="M225.475 171.821L224.218 169.169H217.435L216.178 171.821H208.961L217.5 155.047H224.211L232.75 171.821H225.468H225.475ZM221.914 164.262L220.823 161.942L219.732 164.262H221.907H221.914Z"
                    fill="#781615"
                />
                <path
                    d="M248.802 171.821V164.117L244.28 169.667H243.326L238.826 164.124V171.821H232.223V155.039H239.143L243.94 161.269L248.773 155.039H255.542V171.821H248.802Z"
                    fill="#781615"
                />
                <path
                    d="M257.238 171.821V155.039H275.349V160.337H263.935V160.85H273.24V165.837H263.935V166.523H275.588V171.821H257.238Z"
                    fill="#781615"
                />
                <path
                    d="M130.986 171.778L123.076 163.647V171.778H116.473V154.996H123.169L130.083 162.245V154.996H136.715V171.778H130.986Z"
                    fill="#781615"
                />
                <path
                    d="M138.418 171.778V154.996H156.522V160.294H145.108V160.807H154.412V165.794H145.108V166.48H156.767V171.778H138.418Z"
                    fill="#781615"
                />
                <path
                    d="M173.615 171.778L170.993 163.568L168.356 171.778H162.071L155.938 154.996H162.887L165.38 163.17L168.103 154.996H173.955L176.685 163.17L179.171 154.996H186.034L179.9 171.778H173.615Z"
                    fill="#781615"
                />
                <path
                    d="M201.139 172.277C194.132 172.277 189.949 168.952 189.949 163.387C189.949 157.822 194.132 154.49 201.139 154.49C204.701 154.49 207.822 155.531 209.931 157.41L210.589 157.995L206.204 161.255H210.719V168.598L210.538 168.8C208.588 171.034 205.25 172.269 201.132 172.269L201.139 172.277ZM201.32 159.94C198.337 159.94 196.827 161.096 196.827 163.387C196.827 166.285 199.297 166.9 201.363 166.9C202.599 166.9 203.531 166.697 204.34 166.249V166.105H199.875V161.269H205.228C204.015 160.308 202.946 159.947 201.32 159.947V159.94Z"
                    fill="#781615"
                />
                <path
                    d="M225.429 171.778L224.172 169.126H217.388L216.131 171.778H208.914L217.453 155.004H224.164L232.703 171.778H225.421H225.429ZM221.867 164.226L220.776 161.906L219.685 164.226H221.86H221.867Z"
                    fill="#781615"
                />
                <path
                    d="M248.755 171.778V164.074L244.233 169.624H243.279L238.779 164.081V171.778H232.176V154.996H239.097L243.893 161.226L248.726 154.996H255.495V171.778H248.755Z"
                    fill="#781615"
                />
                <path
                    d="M257.191 171.778V154.996H275.302V160.294H263.888V160.807H273.193V165.794H263.888V166.48H275.541V171.778H257.191Z"
                    fill="#781615"
                />
                <path
                    d="M130.943 171.735L123.033 163.604V171.735H116.43V154.953H123.134L130.04 162.202V154.953H136.672V171.735H130.943Z"
                    fill="#781615"
                />
                <path
                    d="M138.375 171.735V154.953H156.479V160.251H145.065V160.764H154.369V165.751H145.065V166.437H156.724V171.735H138.375Z"
                    fill="#781615"
                />
                <path
                    d="M173.572 171.735L170.95 163.532L168.313 171.735H162.028L155.895 154.953H162.844L165.337 163.127L168.06 154.953H173.912L176.642 163.127L179.128 154.953H185.991L179.857 171.735H173.572Z"
                    fill="#781615"
                />
                <path
                    d="M201.097 172.234C194.089 172.234 189.906 168.909 189.906 163.344C189.906 157.779 194.089 154.447 201.097 154.447C204.658 154.447 207.779 155.488 209.888 157.367L210.546 157.953L206.161 161.212H210.676V168.555L210.495 168.757C208.545 170.991 205.207 172.226 201.089 172.226L201.097 172.234ZM201.277 159.897C198.294 159.897 196.784 161.053 196.784 163.344C196.784 166.242 199.254 166.857 201.32 166.857C202.556 166.857 203.488 166.654 204.297 166.206V166.062H199.832V161.226H205.185C203.972 160.265 202.903 159.904 201.277 159.904V159.897Z"
                    fill="#781615"
                />
                <path
                    d="M225.386 171.736L224.129 169.083H217.345L216.088 171.736H208.871L217.41 154.961H224.121L232.66 171.736H225.378H225.386ZM221.824 164.183L220.733 161.863L219.642 164.183H221.817H221.824Z"
                    fill="#781615"
                />
                <path
                    d="M248.712 171.735V164.031L244.19 169.581H243.236L238.736 164.038V171.735H232.133V154.953H239.054L243.85 161.183L248.683 154.953H255.453V171.735H248.712Z"
                    fill="#781615"
                />
                <path
                    d="M257.148 171.735V154.953H275.26V160.251H263.845V160.764H273.15V165.751H263.845V166.437H275.505V171.735H257.148Z"
                    fill="#781615"
                />
                <path
                    d="M130.9 171.692L122.99 163.561V171.692H116.387V154.91H123.091L129.997 162.159V154.91H136.629V171.692H130.9Z"
                    fill="#781615"
                />
                <path
                    d="M138.332 171.692V154.91H156.436V160.208H145.022V160.721H154.326V165.708H145.022V166.394H156.681V171.692H138.332Z"
                    fill="#781615"
                />
                <path
                    d="M173.529 171.692L170.907 163.489L168.27 171.692H161.985L155.852 154.91H162.801L165.294 163.084L168.017 154.91H173.869L176.599 163.084L179.085 154.91H185.948L179.814 171.692H173.529Z"
                    fill="#781615"
                />
                <path
                    d="M201.061 172.191C194.054 172.191 189.871 168.866 189.871 163.301C189.871 157.736 194.054 154.404 201.061 154.404C204.623 154.404 207.744 155.445 209.853 157.324L210.511 157.91L206.126 161.169H210.641V168.512L210.46 168.714C208.51 170.948 205.172 172.183 201.054 172.183L201.061 172.191ZM201.235 159.854C198.251 159.854 196.741 161.01 196.741 163.301C196.741 166.199 199.212 166.814 201.278 166.814C202.513 166.814 203.445 166.611 204.254 166.163V166.019H199.79V161.184H205.143C203.929 160.222 202.86 159.861 201.235 159.861V159.854Z"
                    fill="#781615"
                />
                <path
                    d="M225.343 171.693L224.086 169.04H217.302L216.045 171.693H208.828L217.367 154.918H224.078L232.617 171.693H225.335H225.343ZM221.781 164.14L220.69 161.82L219.599 164.14H221.774H221.781Z"
                    fill="#781615"
                />
                <path
                    d="M248.669 171.692V163.988L244.147 169.545H243.193L238.693 163.995V171.692H232.09V154.91H239.011L243.807 161.14L248.64 154.91H255.41V171.692H248.669Z"
                    fill="#781615"
                />
                <path
                    d="M257.105 171.692V154.91H275.217V160.208H263.802V160.721H273.107V165.708H263.802V166.394H275.462V171.692H257.105Z"
                    fill="#781615"
                />
                <path
                    d="M130.857 171.647L122.947 163.516V171.647H116.344V154.865H123.048L129.954 162.114V154.865H136.586V171.647H130.857Z"
                    fill="#781615"
                />
                <path
                    d="M138.289 171.647V154.865H156.393V160.163H144.979V160.676H154.283V165.663H144.979V166.349H156.639V171.647H138.289Z"
                    fill="#781615"
                />
                <path
                    d="M173.486 171.647L170.864 163.444L168.227 171.647H161.942L155.809 154.865H162.758L165.251 163.039L167.974 154.865H173.826L176.556 163.039L179.042 154.865H185.905L179.771 171.647H173.486Z"
                    fill="#781615"
                />
                <path
                    d="M201.018 172.146C194.011 172.146 189.828 168.821 189.828 163.256C189.828 157.691 194.011 154.359 201.018 154.359C204.58 154.359 207.701 155.4 209.81 157.279L210.468 157.865L206.083 161.124H210.598V168.467L210.417 168.669C208.467 170.903 205.129 172.139 201.011 172.139L201.018 172.146ZM201.192 159.809C198.208 159.809 196.698 160.965 196.698 163.256C196.698 166.154 199.169 166.769 201.235 166.769C202.47 166.769 203.402 166.566 204.212 166.118V165.974H199.747V161.139H205.1C203.886 160.177 202.817 159.816 201.192 159.816V159.809Z"
                    fill="#781615"
                />
                <path
                    d="M225.3 171.648L224.043 168.995H217.259L216.002 171.648H208.785L217.324 154.873H224.035L232.574 171.648H225.292H225.3ZM221.738 164.095L220.647 161.775L219.556 164.095H221.731H221.738Z"
                    fill="#781615"
                />
                <path
                    d="M248.626 171.647V163.943L244.104 169.501H243.15L238.65 163.95V171.647H232.047V154.865H238.968L243.765 161.095L248.598 154.865H255.367V171.647H248.626Z"
                    fill="#781615"
                />
                <path
                    d="M257.07 171.647V154.865H275.174V160.163H263.76V160.676H273.065V165.663H263.76V166.349H275.42V171.647H257.07Z"
                    fill="#781615"
                />
                <path
                    d="M130.814 171.604L122.911 163.473V171.604H116.301V154.822H123.005L129.911 162.071V154.822H136.543V171.604H130.814Z"
                    fill="#781615"
                />
                <path
                    d="M138.246 171.604V154.822H156.35V160.12H144.936V160.633H154.24V165.62H144.936V166.306H156.596V171.604H138.246Z"
                    fill="#781615"
                />
                <path
                    d="M173.443 171.604L170.821 163.401L168.184 171.604H161.899L155.766 154.822H162.715L165.208 162.996L167.931 154.822H173.783L176.514 162.996L178.999 154.822H185.862L179.728 171.604H173.443Z"
                    fill="#781615"
                />
                <path
                    d="M200.975 172.103C193.968 172.103 189.785 168.778 189.785 163.213C189.785 157.648 193.968 154.316 200.975 154.316C204.537 154.316 207.658 155.357 209.767 157.236L210.425 157.822L206.04 161.081H210.555V168.424L210.374 168.626C208.424 170.86 205.086 172.096 200.968 172.096L200.975 172.103ZM201.149 159.766C198.165 159.766 196.655 160.922 196.655 163.213C196.655 166.111 199.126 166.726 201.192 166.726C202.428 166.726 203.359 166.523 204.169 166.075V165.931H199.704V161.096H205.057C203.843 160.134 202.774 159.773 201.149 159.773V159.766Z"
                    fill="#781615"
                />
                <path
                    d="M225.257 171.605L224 168.952H217.216L215.959 171.605H208.742L217.281 154.83H223.992L232.531 171.605H225.249H225.257ZM221.695 164.052L220.604 161.732L219.513 164.052H221.688H221.695Z"
                    fill="#781615"
                />
                <path
                    d="M248.583 171.604V163.9L244.061 169.458H243.107L238.607 163.907V171.604H232.004V154.822H238.925L243.722 161.052L248.555 154.822H255.324V171.604H248.583Z"
                    fill="#781615"
                />
                <path
                    d="M257.027 171.604V154.822H275.131V160.12H263.717V160.633H273.022V165.62H263.717V166.306H275.377V171.604H257.027Z"
                    fill="#781615"
                />
                <path
                    d="M130.771 171.561L122.868 163.43V171.561H116.258V154.779H122.962L129.868 162.028V154.779H136.5V171.561H130.771Z"
                    fill="#781615"
                />
                <path
                    d="M138.203 171.561V154.779H156.307V160.077H144.893V160.59H154.197V165.577H144.893V166.263H156.553V171.561H138.203Z"
                    fill="#781615"
                />
                <path
                    d="M173.4 171.561L170.778 163.358L168.141 171.561H161.856L155.723 154.779H162.672L165.165 162.953L167.888 154.779H173.74L176.471 162.953L178.956 154.779H185.819L179.685 171.561H173.4Z"
                    fill="#781615"
                />
                <path
                    d="M200.932 172.06C193.925 172.06 189.742 168.735 189.742 163.17C189.742 157.605 193.925 154.273 200.932 154.273C204.494 154.273 207.615 155.314 209.724 157.193L210.382 157.779L205.997 161.038H210.512V168.381L210.331 168.584C208.381 170.817 205.043 172.053 200.925 172.053L200.932 172.06ZM201.106 159.723C198.122 159.723 196.612 160.879 196.612 163.17C196.612 166.068 199.083 166.683 201.149 166.683C202.385 166.683 203.316 166.48 204.126 166.032V165.888H199.661V161.053H205.014C203.8 160.091 202.731 159.73 201.106 159.73V159.723Z"
                    fill="#781615"
                />
                <path
                    d="M225.214 171.562L223.957 168.909H217.173L215.916 171.562H208.699L217.238 154.787H223.95L232.488 171.562H225.207H225.214ZM221.652 164.009L220.561 161.689L219.47 164.009H221.645H221.652Z"
                    fill="#781615"
                />
                <path
                    d="M248.54 171.561V163.857L244.018 169.415H243.072L238.564 163.864V171.561H231.961V154.779H238.882L243.679 161.009L248.512 154.779H255.281V171.561H248.54Z"
                    fill="#781615"
                />
                <path
                    d="M256.984 171.561V154.779H275.088V160.077H263.674V160.59H272.979V165.577H263.674V166.263H275.334V171.561H256.984Z"
                    fill="#781615"
                />
                <path
                    d="M130.771 171.561L122.868 163.43V171.561H116.258V154.779H122.962L129.868 162.028V154.779H136.5V171.561H130.771Z"
                    fill="#781615"
                />
                <path
                    d="M138.203 171.561V154.779H156.307V160.077H144.893V160.59H154.197V165.577H144.893V166.263H156.553V171.561H138.203Z"
                    fill="#781615"
                />
                <path
                    d="M173.4 171.561L170.778 163.358L168.141 171.561H161.856L155.723 154.779H162.672L165.165 162.953L167.888 154.779H173.74L176.471 162.953L178.956 154.779H185.819L179.685 171.561H173.4Z"
                    fill="#781615"
                />
                <path
                    d="M200.932 172.06C193.925 172.06 189.742 168.735 189.742 163.17C189.742 157.605 193.925 154.273 200.932 154.273C204.494 154.273 207.615 155.314 209.724 157.193L210.382 157.779L205.997 161.038H210.512V168.381L210.331 168.584C208.381 170.817 205.043 172.053 200.925 172.053L200.932 172.06ZM201.106 159.723C198.122 159.723 196.612 160.879 196.612 163.17C196.612 166.068 199.083 166.683 201.149 166.683C202.385 166.683 203.316 166.48 204.126 166.032V165.888H199.661V161.053H205.014C203.8 160.091 202.731 159.73 201.106 159.73V159.723Z"
                    fill="#781615"
                />
                <path
                    d="M225.214 171.562L223.957 168.909H217.173L215.916 171.562H208.699L217.238 154.787H223.95L232.488 171.562H225.207H225.214ZM221.652 164.009L220.561 161.689L219.47 164.009H221.645H221.652Z"
                    fill="#781615"
                />
                <path
                    d="M248.54 171.561V163.857L244.018 169.415H243.072L238.564 163.864V171.561H231.961V154.779H238.882L243.679 161.009L248.512 154.779H255.281V171.561H248.54Z"
                    fill="#781615"
                />
                <path
                    d="M256.984 171.561V154.779H275.088V160.077H263.674V160.59H272.979V165.577H263.674V166.263H275.334V171.561H256.984Z"
                    fill="#781615"
                />
                <path
                    d="M127.405 150.966H133.069V167.766H127.933L118.189 157.71V167.766H112.549V150.966H118.741L127.405 160.086V150.966ZM142.238 163.542H154.958V167.766H136.502V150.966H154.694V155.19H142.238V157.326H152.39V161.214H142.238V163.542ZM180.78 150.966H186.564L180.444 167.766H174.708L171.276 156.99L167.82 167.766H162.084L155.964 150.966H161.844L165.108 161.718L168.684 150.966H173.94L177.516 161.718L180.78 150.966ZM213.852 157.83V164.79C211.932 166.998 208.596 168.318 204.18 168.318C197.148 168.318 192.756 165.126 192.756 159.366C192.756 153.606 197.148 150.414 204.18 150.414C208.38 150.414 211.404 151.758 213.252 153.414L209.172 156.462C207.708 155.286 206.388 154.806 204.372 154.806C200.604 154.806 198.684 156.486 198.684 159.366C198.684 162.27 200.676 163.998 204.42 163.998C206.028 163.998 207.3 163.71 208.452 162.942V161.55H203.58V157.83H213.852ZM231.173 167.766L229.805 164.862H221.405L220.037 167.766H213.941L222.461 150.966H228.821L237.341 167.766H231.173ZM223.181 161.07H228.029L225.605 155.886L223.181 161.07ZM256.495 150.966H262.711V167.766H256.927V157.902L250.831 165.414H250.543L244.471 157.902V167.766H238.831V150.966H245.215L250.831 158.286L256.495 150.966ZM271.871 163.542H284.591V167.766H266.135V150.966H284.327V155.19H271.871V157.326H282.023V161.214H271.871V163.542Z"
                    fill="white"
                />
                </g>
                <g id="button-blue" @click="replayGame" :class="loadingAction ? 'cursor-not-allowed opacity-50 pointer-events-none' : 'cursor-pointer'">
                <path
                    d="M303.113 214.773H87.7455C79.4227 214.773 72.6758 221.523 72.6758 229.85V262.907C72.6758 271.234 79.4227 277.984 87.7455 277.984H303.113C311.436 277.984 318.183 271.234 318.183 262.907V229.85C318.183 221.523 311.436 214.773 303.113 214.773Z"
                    fill="#F7D073"
                />
                <path
                    d="M301.544 217.086H89.3262C81.4982 217.086 75.1523 223.435 75.1523 231.266V261.498C75.1523 269.329 81.4982 275.678 89.3262 275.678H301.544C309.372 275.678 315.718 269.329 315.718 261.498V231.266C315.718 223.435 309.372 217.086 301.544 217.086Z"
                    fill="#E88439"
                />
                <path
                    d="M302.905 220.859H87.9639C82.7652 220.859 78.5508 225.076 78.5508 230.277V262.799C78.5508 268 82.7652 272.217 87.9639 272.217H302.905C308.104 272.217 312.319 268 312.319 262.799V230.277C312.319 225.076 308.104 220.859 302.905 220.859Z"
                    fill="#1C5F02"
                />
                <path
                    d="M301.459 217.15H89.3995C81.5914 217.15 75.2617 223.483 75.2617 231.294V261.461C75.2617 269.272 81.5914 275.605 89.3995 275.605H301.459C309.267 275.605 315.596 269.272 315.596 261.461V231.294C315.596 223.483 309.267 217.15 301.459 217.15Z"
                    fill="#E88439"
                />
                <path
                    d="M302.823 220.916H88.0477C82.8609 220.916 78.6562 225.123 78.6562 230.312V262.755C78.6562 267.944 82.8609 272.15 88.0477 272.15H302.823C308.01 272.15 312.215 267.944 312.215 262.755V230.312C312.215 225.123 308.01 220.916 302.823 220.916Z"
                    fill="#004A7C"
                />
                <path
                    d="M302.786 223.143H88.0689C84.0592 223.143 80.8086 226.395 80.8086 230.406V262.662C80.8086 266.673 84.0592 269.925 88.0689 269.925H302.786C306.796 269.925 310.047 266.673 310.047 262.662V230.406C310.047 226.395 306.796 223.143 302.786 223.143Z"
                    fill="#2E7BAF"
                />
                <path
                    d="M305.011 265.01C305.011 265.01 304.975 269.188 302.765 269.925H88.0905C85.8799 269.181 85.8438 265.01 85.8438 265.01L90.33 260.58H300.525L305.011 265.01Z"
                    fill="#2A76B4"
                />
                <path
                    d="M90.3301 232.806V260.58L85.8439 265.01C81.9211 264.671 80.8086 262.669 80.8086 262.669V230.406C80.8086 230.406 81.9211 228.404 85.8439 228.064L90.3301 232.806Z"
                    fill="#45B0D6"
                />
                <path
                    d="M305.011 228.057L300.525 232.798H90.33L85.8438 228.057C85.8438 228.057 85.8799 223.88 88.0905 223.143H302.765C304.975 223.887 305.011 228.057 305.011 228.057Z"
                    fill="#38A6DB"
                />
                <path
                    d="M88.0906 223.142C85.88 223.886 85.8439 228.057 85.8439 228.057C81.9211 228.396 80.8086 230.398 80.8086 230.398C80.8086 226.387 84.0595 223.135 88.0689 223.135H88.0906V223.142Z"
                    fill="#4385AA"
                />
                <path
                    d="M310.055 262.668C310.055 266.679 306.805 269.924 302.795 269.924H302.773C304.984 269.18 305.02 265.01 305.02 265.01C308.943 264.67 310.055 262.668 310.055 262.668Z"
                    fill="#39A7D8"
                />
                <path
                    d="M310.055 230.405C310.055 230.405 308.943 228.403 305.02 228.063C305.02 228.063 304.984 223.886 302.773 223.148H302.795C306.805 223.148 310.055 226.401 310.055 230.412V230.405Z"
                    fill="#4385AA"
                />
                <path
                    d="M88.0906 269.924H88.0689C84.0595 269.924 80.8086 266.672 80.8086 262.668C80.8086 262.668 81.9211 264.67 85.8439 265.01C85.8439 265.01 85.88 269.187 88.0906 269.924Z"
                    fill="#39A7D8"
                />
                <path d="M300.527 232.805H90.332V260.579H300.527V232.805Z" fill="#2D9FDD" />
                <path
                    d="M153.234 256.974L149.499 252.457H146.949V256.974H140.188V240.199H151.833C156.818 240.199 159.917 242.548 159.917 246.328C159.917 248.677 158.732 250.491 156.55 251.532L161.253 256.974H153.227H153.234ZM151.399 247.448C153.054 247.448 153.054 246.856 153.054 246.458C153.054 246.061 153.054 245.468 151.399 245.468H146.949V247.448H151.399Z"
                    fill="#004A7C"
                />
                <path
                    d="M161.016 256.973V240.191H179.119V245.489H167.705V246.002H177.01V250.989H167.705V251.676H179.365V256.973H161.016Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.359 256.974V240.199H191.875C196.939 240.199 199.959 242.534 199.959 246.444C199.959 250.354 196.939 252.71 191.875 252.71H187.165V256.981H180.359V256.974ZM191.434 247.687C193.088 247.687 193.088 246.957 193.088 246.566C193.088 246.176 193.088 245.468 191.434 245.468H187.157V247.687H191.434Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.547 256.973V240.191H207.352V251.437H217.228V256.973H200.547Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.972 256.974L230.715 254.321H223.931L222.674 256.974H215.457L223.996 240.199H230.707L239.246 256.974H231.964H231.972ZM228.41 249.421L227.319 247.101L226.228 249.421H228.403H228.41Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.419 256.973V251.372L233.711 240.191H241.397L244.843 245.655L248.275 240.191H255.94L248.224 251.372V256.973H241.419Z"
                    fill="#004A7C"
                />
                <path
                    d="M153.188 256.931L149.453 252.414H146.902V256.931H140.141V240.156H151.786C156.771 240.156 159.87 242.505 159.87 246.285C159.87 248.634 158.685 250.448 156.503 251.489L161.206 256.931H153.18H153.188ZM151.353 247.405C153.007 247.405 153.007 246.813 153.007 246.415C153.007 246.018 153.007 245.425 151.353 245.425H146.902V247.405H151.353Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.969 256.93V240.148H179.073V245.446H167.658V245.959H176.963V250.946H167.658V251.633H179.318V256.93H160.969Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.312 256.931V240.156H191.828C196.892 240.156 199.912 242.491 199.912 246.401C199.912 250.311 196.892 252.667 191.828 252.667H187.118V256.938H180.312V256.931ZM191.387 247.644C193.042 247.644 193.042 246.914 193.042 246.524C193.042 246.133 193.042 245.425 191.387 245.425H187.11V247.644H191.387Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.5 256.93V240.148H207.305V251.394H217.181V256.93H200.5Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.925 256.931L230.668 254.278H223.884L222.627 256.931H215.41L223.949 240.156H230.66L239.199 256.931H231.917H231.925ZM228.363 249.378L227.272 247.058L226.181 249.378H228.356H228.363Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.372 256.93V251.329L233.664 240.148H241.351L244.797 245.612L248.228 240.148H255.893L248.177 251.329V256.93H241.372Z"
                    fill="#004A7C"
                />
                <path
                    d="M153.145 256.888L149.41 252.371H146.86V256.888H140.098V240.113H151.743C156.728 240.113 159.827 242.462 159.827 246.242C159.827 248.591 158.642 250.405 156.46 251.446L161.163 256.888H153.137H153.145ZM151.31 247.362C152.964 247.362 152.964 246.77 152.964 246.372C152.964 245.975 152.964 245.382 151.31 245.382H146.86V247.362H151.31Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.926 256.887V240.105H179.03V245.403H167.615V245.916H176.92V250.903H167.615V251.59H179.275V256.887H160.926Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.27 256.888V240.113H191.785C196.849 240.113 199.869 242.448 199.869 246.358C199.869 250.268 196.849 252.624 191.785 252.624H187.075V256.895H180.27V256.888ZM191.344 247.601C192.999 247.601 192.999 246.871 192.999 246.481C192.999 246.09 192.999 245.382 191.344 245.382H187.068V247.601H191.344Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.457 256.887V240.105H207.262V251.351H217.138V256.887H200.457Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.882 256.888L230.625 254.235H223.841L222.584 256.888H215.367L223.906 240.113H230.617L239.156 256.888H231.874H231.882ZM228.32 249.335L227.229 247.015L226.138 249.335H228.313H228.32Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.329 256.887V251.286L233.621 240.105H241.308L244.754 245.569L248.185 240.105H255.85L248.135 251.286V256.887H241.329Z"
                    fill="#004A7C"
                />
                <path
                    d="M153.102 256.845L149.367 252.328H146.817V256.845H140.055V240.07H151.7C156.685 240.07 159.784 242.419 159.784 246.199C159.784 248.548 158.599 250.362 156.417 251.403L161.12 256.845H153.094H153.102ZM151.267 247.319C152.921 247.319 152.921 246.727 152.921 246.329C152.921 245.932 152.921 245.339 151.267 245.339H146.817V247.319H151.267Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.883 256.844V240.062H178.987V245.36H167.572V245.873H176.877V250.86H167.572V251.547H179.232V256.844H160.883Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.227 256.845V240.07H191.742C196.806 240.07 199.826 242.405 199.826 246.315C199.826 250.225 196.806 252.581 191.742 252.581H187.032V256.852H180.227V256.845ZM191.301 247.558C192.956 247.558 192.956 246.828 192.956 246.438C192.956 246.047 192.956 245.339 191.301 245.339H187.025V247.558H191.301Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.414 256.844V240.062H207.219V251.308H217.095V256.844H200.414Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.839 256.845L230.582 254.192H223.798L222.541 256.845H215.324L223.863 240.07H230.574L239.113 256.845H231.832H231.839ZM228.277 249.292L227.186 246.972L226.095 249.292H228.27H228.277Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.286 256.844V251.243L233.578 240.062H241.265L244.711 245.526L248.142 240.062H255.807L248.092 251.243V256.844H241.286Z"
                    fill="#004A7C"
                />
                <path
                    d="M153.059 256.802L149.324 252.285H146.774V256.802H140.012V240.027H151.657C156.642 240.027 159.741 242.376 159.741 246.156C159.741 248.505 158.556 250.319 156.375 251.36L161.077 256.802H153.051H153.059ZM151.224 247.276C152.878 247.276 152.878 246.684 152.878 246.286C152.878 245.889 152.878 245.296 151.224 245.296H146.774V247.276H151.224Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.84 256.801V240.02H178.944V245.317H167.529V245.83H176.834V250.817H167.529V251.504H179.189V256.801H160.84Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.184 256.802V240.027H191.699C196.763 240.027 199.783 242.362 199.783 246.272C199.783 250.182 196.763 252.538 191.699 252.538H186.989V256.809H180.184V256.802ZM191.258 247.515C192.913 247.515 192.913 246.785 192.913 246.395C192.913 246.004 192.913 245.296 191.258 245.296H186.982V247.515H191.258Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.371 256.801V240.02H207.176V251.265H217.052V256.801H200.371Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.796 256.802L230.539 254.15H223.755L222.498 256.802H215.281L223.82 240.027H230.532L239.071 256.802H231.789H231.796ZM228.234 249.249L227.143 246.929L226.053 249.249H228.227H228.234Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.243 256.801V251.2L233.535 240.02H241.222L244.668 245.483L248.099 240.02H255.764L248.049 251.2V256.801H241.243Z"
                    fill="#004A7C"
                />
                <path
                    d="M153.016 256.757L149.281 252.24H146.731V256.757H139.969V239.982H151.614C156.599 239.982 159.698 242.331 159.698 246.111C159.698 248.46 158.513 250.274 156.332 251.315L161.035 256.757H153.008H153.016ZM151.181 247.231C152.835 247.231 152.835 246.639 152.835 246.241C152.835 245.844 152.835 245.251 151.181 245.251H146.731V247.231H151.181Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.797 256.756V239.975H178.901V245.272H167.486V245.785H176.791V250.772H167.486V251.459H179.146V256.756H160.797Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.141 256.757V239.982H191.656C196.72 239.982 199.74 242.317 199.74 246.227C199.74 250.137 196.72 252.493 191.656 252.493H186.946V256.764H180.141V256.757ZM191.215 247.47C192.87 247.47 192.87 246.74 192.87 246.35C192.87 245.959 192.87 245.251 191.215 245.251H186.939V247.47H191.215Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.328 256.756V239.975H207.133V251.22H217.009V256.756H200.328Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.753 256.757L230.496 254.105H223.712L222.455 256.757H215.238L223.777 239.982H230.489L239.028 256.757H231.746H231.753ZM228.191 249.204L227.1 246.885L226.01 249.204H228.184H228.191Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.2 256.756V251.155L233.492 239.975H241.179L244.625 245.438L248.056 239.975H255.721L248.006 251.155V256.756H241.2Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.973 256.714L149.238 252.197H146.688V256.714H139.926V239.939H151.571C156.556 239.939 159.655 242.288 159.655 246.068C159.655 248.417 158.47 250.231 156.289 251.272L160.992 256.714H152.965H152.973ZM151.138 247.188C152.792 247.188 152.792 246.596 152.792 246.198C152.792 245.801 152.792 245.208 151.138 245.208H146.688V247.188H151.138Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.754 256.713V239.932H178.858V245.229H167.444V245.742H176.748V250.729H167.444V251.416H179.103V256.713H160.754Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.098 256.714V239.939H191.613C196.677 239.939 199.697 242.274 199.697 246.184C199.697 250.094 196.677 252.45 191.613 252.45H186.903V256.721H180.098V256.714ZM191.172 247.427C192.827 247.427 192.827 246.697 192.827 246.307C192.827 245.916 192.827 245.208 191.172 245.208H186.896V247.427H191.172Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.285 256.713V239.932H207.09V251.177H216.966V256.713H200.285Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.71 256.714L230.453 254.062H223.669L222.412 256.714H215.195L223.734 239.939H230.446L238.985 256.714H231.703H231.71ZM228.148 249.162L227.057 246.842L225.967 249.162H228.141H228.148Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.165 256.713V251.112L233.449 239.932H241.136L244.582 245.395L248.013 239.932H255.678L247.963 251.112V256.713H241.165Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.938 256.671L149.203 252.154H146.652V256.671H139.891V239.896H151.536C156.521 239.896 159.62 242.245 159.62 246.025C159.62 248.374 158.435 250.188 156.253 251.229L160.956 256.671H152.93H152.938ZM151.095 247.145C152.75 247.145 152.75 246.553 152.75 246.155C152.75 245.758 152.75 245.165 151.095 245.165H146.645V247.145H151.095Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.711 256.67V239.889H178.815V245.186H167.401V245.699H176.705V250.686H167.401V251.373H179.06V256.67H160.711Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.059 256.671V239.896H191.574C196.638 239.896 199.658 242.231 199.658 246.141C199.658 250.051 196.638 252.407 191.574 252.407H186.864V256.678H180.059V256.671ZM191.133 247.384C192.788 247.384 192.788 246.654 192.788 246.264C192.788 245.873 192.788 245.165 191.133 245.165H186.857V247.384H191.133Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.242 256.67V239.889H207.047V251.134H216.923V256.67H200.242Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.667 256.671L230.41 254.019H223.626L222.369 256.671H215.152L223.691 239.896H230.403L238.942 256.671H231.66H231.667ZM228.105 249.119L227.014 246.799L225.924 249.119H228.098H228.105Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.122 256.67V251.069L233.406 239.889H241.093L244.539 245.353L247.97 239.889H255.635L247.92 251.069V256.67H241.122Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.895 256.628L149.16 252.111H146.61V256.628H139.848V239.854H151.493C156.478 239.854 159.577 242.202 159.577 245.982C159.577 248.331 158.392 250.145 156.21 251.186L160.913 256.628H152.887H152.895ZM151.052 247.103C152.707 247.103 152.707 246.51 152.707 246.112C152.707 245.715 152.707 245.122 151.052 245.122H146.602V247.103H151.052Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.668 256.628V239.846H178.772V245.143H167.358V245.656H176.662V250.643H167.358V251.33H179.017V256.628H160.668Z"
                    fill="#004A7C"
                />
                <path
                    d="M180.016 256.628V239.854H191.531C196.595 239.854 199.615 242.188 199.615 246.098C199.615 250.008 196.595 252.364 191.531 252.364H186.821V256.635H180.016V256.628ZM191.09 247.341C192.745 247.341 192.745 246.611 192.745 246.221C192.745 245.831 192.745 245.122 191.09 245.122H186.814V247.341H191.09Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.199 256.628V239.846H207.004V251.091H216.88V256.628H200.199Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.624 256.628L230.367 253.976H223.583L222.326 256.628H215.109L223.648 239.854H230.36L238.899 256.628H231.617H231.624ZM228.07 249.076L226.979 246.756L225.888 249.076H228.062H228.07Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.079 256.628V251.026L233.363 239.846H241.05L244.496 245.31L247.927 239.846H255.592L247.877 251.026V256.628H241.079Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.852 256.585L149.117 252.068H146.567V256.585H139.805V239.811H151.45C156.435 239.811 159.534 242.159 159.534 245.939C159.534 248.288 158.349 250.102 156.167 251.143L160.87 256.585H152.844H152.852ZM151.009 247.06C152.664 247.06 152.664 246.467 152.664 246.069C152.664 245.672 152.664 245.079 151.009 245.079H146.559V247.06H151.009Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.625 256.585V239.803H178.729V245.1H167.315V245.614H176.619V250.6H167.315V251.287H178.974V256.585H160.625Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.973 256.585V239.811H191.488C196.552 239.811 199.572 242.145 199.572 246.055C199.572 249.965 196.552 252.321 191.488 252.321H186.778V256.592H179.973V256.585ZM191.047 247.298C192.702 247.298 192.702 246.568 192.702 246.178C192.702 245.788 192.702 245.079 191.047 245.079H186.771V247.298H191.047Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.156 256.585V239.803H206.961V251.048H216.837V256.585H200.156Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.581 256.585L230.324 253.933H223.54L222.283 256.585H215.066L223.605 239.811H230.317L238.856 256.585H231.574H231.581ZM228.027 249.033L226.936 246.713L225.845 249.033H228.019H228.027Z"
                    fill="#004A7C"
                />
                <path
                    d="M241.036 256.585V250.983L233.32 239.803H241.007L244.453 245.267L247.884 239.803H255.549L247.834 250.983V256.585H241.036Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.805 256.54L149.07 252.023H146.52V256.54H139.758V239.766H151.403C156.388 239.766 159.487 242.115 159.487 245.894C159.487 248.243 158.302 250.057 156.121 251.098L160.824 256.54H152.797H152.805ZM150.963 247.015C152.617 247.015 152.617 246.422 152.617 246.024C152.617 245.627 152.617 245.034 150.963 245.034H146.512V247.015H150.963Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.578 256.54V239.758H178.682V245.055H167.268V245.569H176.572V250.555H167.268V251.242H178.928V256.54H160.578Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.926 256.54V239.766H191.441C196.505 239.766 199.525 242.1 199.525 246.01C199.525 249.92 196.505 252.276 191.441 252.276H186.731V256.547H179.926V256.54ZM191 247.253C192.655 247.253 192.655 246.523 192.655 246.133C192.655 245.743 192.655 245.034 191 245.034H186.724V247.253H191Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.109 256.54V239.758H206.915V251.004H216.79V256.54H200.109Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.534 256.54L230.277 253.888H223.494L222.237 256.54H215.02L223.559 239.766H230.27L238.809 256.54H231.527H231.534ZM227.98 248.988L226.889 246.668L225.798 248.988H227.973H227.98Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.989 256.54V250.938L233.273 239.758H240.96L244.406 245.222L247.837 239.758H255.502L247.787 250.938V256.54H240.989Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.762 256.497L149.027 251.98H146.477V256.497H139.715V239.723H151.36C156.345 239.723 159.444 242.072 159.444 245.851C159.444 248.2 158.259 250.014 156.078 251.055L160.781 256.497H152.755H152.762ZM150.92 246.972C152.574 246.972 152.574 246.379 152.574 245.982C152.574 245.584 152.574 244.991 150.92 244.991H146.469V246.972H150.92Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.535 256.497V239.715H178.639V245.012H167.225V245.526H176.53V250.512H167.225V251.199H178.885V256.497H160.535Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.883 256.497V239.723H191.398C196.462 239.723 199.482 242.057 199.482 245.967C199.482 249.877 196.462 252.233 191.398 252.233H186.688V256.504H179.883V256.497ZM190.965 247.21C192.619 247.21 192.619 246.48 192.619 246.09C192.619 245.7 192.619 244.991 190.965 244.991H186.688V247.21H190.965Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.066 256.497V239.715H206.872V250.961H216.747V256.497H200.066Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.491 256.497L230.234 253.845H223.451L222.194 256.497H214.977L223.516 239.723H230.227L238.766 256.497H231.484H231.491ZM227.937 248.945L226.846 246.625L225.755 248.945H227.93H227.937Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.946 256.497V250.895L233.23 239.715H240.917L244.363 245.179L247.794 239.715H255.459L247.744 250.895V256.497H240.946Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.719 256.454L148.984 251.937H146.434V256.454H139.672V239.68H151.317C156.302 239.68 159.401 242.029 159.401 245.808C159.401 248.157 158.216 249.971 156.035 251.012L160.738 256.454H152.712H152.719ZM150.877 246.929C152.531 246.929 152.531 246.336 152.531 245.939C152.531 245.541 152.531 244.948 150.877 244.948H146.426V246.929H150.877Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.492 256.454V239.68H178.596V244.97H167.182V245.483H176.487V250.47H167.182V251.157H178.842V256.454H160.492Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.84 256.454V239.68H191.355C196.419 239.68 199.439 242.014 199.439 245.924C199.439 249.834 196.419 252.19 191.355 252.19H186.645V256.462H179.84V256.454ZM190.922 247.167C192.576 247.167 192.576 246.437 192.576 246.047C192.576 245.657 192.576 244.948 190.922 244.948H186.645V247.167H190.922Z"
                    fill="#004A7C"
                />
                <path
                    d="M200.023 256.454V239.68H206.829V250.918H216.704V256.454H200.023Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.448 256.454L230.191 253.802H223.408L222.151 256.454H214.934L223.473 239.68H230.184L238.723 256.454H231.441H231.448ZM227.894 248.902L226.803 246.582L225.712 248.902H227.887H227.894Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.903 256.454V250.853L233.188 239.68H240.874L244.327 245.136L247.751 239.68H255.416L247.701 250.853V256.454H240.903Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.676 256.409L148.941 251.892H146.391V256.409H139.629V239.635H151.274C156.259 239.635 159.358 241.984 159.358 245.764C159.358 248.112 158.173 249.926 155.992 250.967L160.695 256.409H152.669H152.676ZM150.834 246.884C152.488 246.884 152.488 246.291 152.488 245.894C152.488 245.496 152.488 244.903 150.834 244.903H146.384V246.884H150.834Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.449 256.409V239.635H178.553V244.925H167.139V245.438H176.444V250.425H167.139V251.112H178.799V256.409H160.449Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.797 256.409V239.635H191.312C196.376 239.635 199.396 241.969 199.396 245.879C199.396 249.789 196.376 252.145 191.312 252.145H186.602V256.417H179.797V256.409ZM190.879 247.122C192.533 247.122 192.533 246.392 192.533 246.002C192.533 245.612 192.533 244.903 190.879 244.903H186.602V247.122H190.879Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.98 256.409V239.635H206.786V250.873H216.661V256.409H199.98Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.405 256.409L230.148 253.757H223.365L222.108 256.409H214.891L223.43 239.635H230.141L238.68 256.409H231.398H231.405ZM227.851 248.857L226.76 246.537L225.669 248.857H227.844H227.851Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.86 256.409V250.808L233.145 239.635H240.831L244.284 245.091L247.709 239.635H255.373L247.665 250.808V256.409H240.86Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.633 256.366L148.898 251.849H146.348V256.366H139.586V239.592H151.231C156.216 239.592 159.315 241.941 159.315 245.721C159.315 248.069 158.13 249.883 155.949 250.924L160.652 256.366H152.626H152.633ZM150.791 246.841C152.445 246.841 152.445 246.248 152.445 245.851C152.445 245.453 152.445 244.86 150.791 244.86H146.341V246.841H150.791Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.406 256.366V239.592H178.51V244.882H167.096V245.395H176.401V250.382H167.096V251.069H178.756V256.366H160.406Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.754 256.366V239.592H191.269C196.333 239.592 199.353 241.926 199.353 245.836C199.353 249.746 196.333 252.102 191.269 252.102H186.559V256.374H179.754V256.366ZM190.836 247.079C192.49 247.079 192.49 246.349 192.49 245.959C192.49 245.569 192.49 244.86 190.836 244.86H186.559V247.079H190.836Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.938 256.366V239.592H206.743V250.83H216.618V256.366H199.938Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.362 256.366L230.105 253.714H223.322L222.065 256.366H214.848L223.387 239.592H230.098L238.637 256.366H231.355H231.362ZM227.808 248.814L226.717 246.494L225.626 248.814H227.801H227.808Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.817 256.366V250.765L233.102 239.592H240.788L244.241 245.048L247.666 239.592H255.33L247.622 250.765V256.366H240.817Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.59 256.323L148.855 251.806H146.305V256.323H139.543V239.549H151.188C156.173 239.549 159.272 241.898 159.272 245.678C159.272 248.026 158.087 249.841 155.906 250.881L160.609 256.323H152.583H152.59ZM150.748 246.798C152.402 246.798 152.402 246.205 152.402 245.808C152.402 245.41 152.402 244.818 150.748 244.818H146.298V246.798H150.748Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.363 256.323V239.549H178.467V244.839H167.053V245.352H176.358V250.339H167.053V251.026H178.713V256.323H160.363Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.711 256.323V239.549H191.226C196.29 239.549 199.31 241.883 199.31 245.793C199.31 249.703 196.29 252.059 191.226 252.059H186.516V256.331H179.711V256.323ZM190.793 247.036C192.447 247.036 192.447 246.306 192.447 245.916C192.447 245.526 192.447 244.818 190.793 244.818H186.516V247.036H190.793Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.895 256.323V239.549H206.7V250.787H216.575V256.323H199.895Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.319 256.323L230.062 253.671H223.279L222.022 256.323H214.805L223.344 239.549H230.055L238.594 256.323H231.312H231.319ZM227.765 248.771L226.674 246.451L225.583 248.771H227.758H227.765Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.774 256.323V250.722L233.059 239.549H240.745L244.198 245.005L247.623 239.549H255.287L247.579 250.722V256.323H240.774Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.547 256.28L148.812 251.763H146.262V256.28H139.5V239.506H151.145C156.13 239.506 159.229 241.855 159.229 245.635C159.229 247.983 158.045 249.798 155.863 250.838L160.566 256.28H152.54H152.547ZM150.705 246.755C152.359 246.755 152.359 246.162 152.359 245.765C152.359 245.367 152.359 244.775 150.705 244.775H146.255V246.755H150.705Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.32 256.28V239.506H178.424V244.796H167.01V245.309H176.315V250.296H167.01V250.983H178.67V256.28H160.32Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.668 256.28V239.506H191.183C196.248 239.506 199.267 241.84 199.267 245.75C199.267 249.66 196.248 252.016 191.183 252.016H186.473V256.288H179.668V256.28ZM190.75 247.001C192.404 247.001 192.404 246.271 192.404 245.88C192.404 245.49 192.404 244.782 190.75 244.782H186.473V247.001H190.75Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.852 256.28V239.506H206.657V250.744H216.532V256.28H199.852Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.276 256.28L230.019 253.628H223.236L221.979 256.28H214.762L223.301 239.506H230.012L238.551 256.28H231.269H231.276ZM227.722 248.728L226.631 246.408L225.54 248.728H227.715H227.722Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.732 256.28V250.679L233.023 239.506H240.703L244.156 244.962L247.587 239.506H255.245L247.537 250.679V256.28H240.732Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.504 256.238L148.769 251.72H146.219V256.238H139.457V239.463H151.102C156.087 239.463 159.186 241.812 159.186 245.592C159.186 247.941 158.002 249.755 155.82 250.795L160.523 256.238H152.497H152.504ZM150.662 246.712C152.316 246.712 152.316 246.119 152.316 245.722C152.316 245.324 152.316 244.732 150.662 244.732H146.212V246.712H150.662Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.277 256.238V239.463H178.388V244.753H166.974V245.266H176.272V250.253H166.974V250.94H178.627V256.238H160.277Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.625 256.238V239.463H191.14C196.205 239.463 199.224 241.797 199.224 245.707C199.224 249.617 196.205 251.973 191.14 251.973H186.43V256.245H179.625V256.238ZM190.707 246.958C192.361 246.958 192.361 246.228 192.361 245.837C192.361 245.447 192.361 244.739 190.707 244.739H186.43V246.958H190.707Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.816 256.238V239.463H206.614V250.701H216.49V256.238H199.816Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.233 256.238L229.976 253.585H223.193L221.936 256.238H214.719L223.258 239.463H229.969L238.508 256.238H231.226H231.233ZM227.679 248.685L226.588 246.365L225.497 248.685H227.672H227.679Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.689 256.238V250.636L232.98 239.463H240.66L244.113 244.92L247.544 239.463H255.202L247.494 250.636V256.238H240.689Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.461 256.193L148.726 251.676H146.176V256.193H139.414V239.418H151.059C156.044 239.418 159.143 241.767 159.143 245.547C159.143 247.896 157.959 249.71 155.777 250.75L160.48 256.193H152.454H152.461ZM150.619 246.667C152.273 246.667 152.273 246.074 152.273 245.677C152.273 245.279 152.273 244.687 150.619 244.687H146.169V246.667H150.619Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.234 256.193V239.418H178.345V244.708H166.931V245.222H176.229V250.208H166.931V250.895H178.584V256.193H160.234Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.582 256.193V239.418H191.097C196.162 239.418 199.181 241.752 199.181 245.662C199.181 249.572 196.162 251.928 191.097 251.928H186.387V256.2H179.582V256.193ZM190.664 246.913C192.318 246.913 192.318 246.183 192.318 245.792C192.318 245.402 192.318 244.694 190.664 244.694H186.387V246.913H190.664Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.773 256.193V239.418H206.571V250.656H216.447V256.193H199.773Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.19 256.193L229.933 253.54H223.15L221.893 256.193H214.676L223.215 239.418H229.926L238.465 256.193H231.183H231.19ZM227.636 248.64L226.545 246.32L225.454 248.64H227.629H227.636Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.646 256.193V250.591L232.938 239.418H240.617L244.07 244.875L247.501 239.418H255.159L247.451 250.591V256.193H240.646Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.418 256.15L148.683 251.633H146.133V256.15H139.371V239.375H151.017C156.001 239.375 159.1 241.724 159.1 245.504C159.1 247.853 157.916 249.667 155.734 250.707L160.437 256.15H152.411H152.418ZM150.576 246.624C152.23 246.624 152.23 246.031 152.23 245.634C152.23 245.236 152.23 244.644 150.576 244.644H146.126V246.624H150.576Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.191 256.15V239.375H178.302V244.665H166.888V245.179H176.186V250.165H166.888V250.852H178.541V256.15H160.191Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.539 256.15V239.375H191.054C196.119 239.375 199.138 241.709 199.138 245.619C199.138 249.529 196.119 251.885 191.054 251.885H186.344V256.157H179.539V256.15ZM190.621 246.87C192.275 246.87 192.275 246.14 192.275 245.749C192.275 245.359 192.275 244.651 190.621 244.651H186.344V246.87H190.621Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.73 256.15V239.375H206.528V250.613H216.404V256.15H199.73Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.147 256.15L229.89 253.497H223.107L221.85 256.15H214.633L223.172 239.375H229.883L238.422 256.15H231.14H231.147ZM227.593 248.597L226.502 246.277L225.411 248.597H227.586H227.593Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.603 256.15V250.548L232.895 239.375H240.574L244.027 244.832L247.458 239.375H255.116L247.408 250.548V256.15H240.603Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.371 256.107L148.636 251.59H146.086V256.107H139.324V239.332H150.97C155.954 239.332 159.053 241.681 159.053 245.461C159.053 247.81 157.869 249.624 155.687 250.664L160.39 256.107H152.364H152.371ZM150.529 246.581C152.183 246.581 152.183 245.988 152.183 245.591C152.183 245.193 152.183 244.601 150.529 244.601H146.079V246.581H150.529Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.145 256.107V239.332H178.256V244.622H166.841V245.136H176.139V250.122H166.841V250.809H178.494V256.107H160.145Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.492 256.107V239.332H191.008C196.072 239.332 199.091 241.666 199.091 245.576C199.091 249.486 196.072 251.843 191.008 251.843H186.297V256.114H179.492V256.107ZM190.574 246.827C192.228 246.827 192.228 246.097 192.228 245.707C192.228 245.316 192.228 244.608 190.574 244.608H186.297V246.827H190.574Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.684 256.107V239.332H206.482V250.571H216.357V256.107H199.684Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.1 256.107L229.843 253.454H223.06L221.803 256.107H214.586L223.125 239.332H229.836L238.375 256.107H231.093H231.1ZM227.546 248.554L226.455 246.234L225.364 248.554H227.539H227.546Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.556 256.107V250.505L232.848 239.332H240.527L243.98 244.789L247.412 239.332H255.069L247.361 250.505V256.107H240.556Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.328 256.064L148.593 251.547H146.043V256.064H139.281V239.289H150.927C155.911 239.289 159.011 241.638 159.011 245.418C159.011 247.767 157.826 249.581 155.644 250.621L160.347 256.064H152.321H152.328ZM150.486 246.538C152.14 246.538 152.14 245.945 152.14 245.548C152.14 245.15 152.14 244.558 150.486 244.558H146.036V246.538H150.486Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.102 256.064V239.289H178.213V244.587H166.798V245.093H176.096V250.079H166.798V250.773H178.451V256.064H160.102Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.449 256.064V239.289H190.965C196.029 239.289 199.048 241.623 199.048 245.533C199.048 249.443 196.029 251.8 190.965 251.8H186.254V256.071H179.449V256.064ZM190.531 246.784C192.185 246.784 192.185 246.054 192.185 245.664C192.185 245.273 192.185 244.565 190.531 244.565H186.254V246.784H190.531Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.641 256.064V239.289H206.439V250.528H216.314V256.064H199.641Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.057 256.064L229.8 253.411H223.017L221.76 256.064H214.543L223.082 239.289H229.793L238.332 256.064H231.05H231.057ZM227.503 248.511L226.412 246.191L225.321 248.511H227.496H227.503Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.513 256.064V250.462L232.805 239.289H240.484L243.937 244.746L247.369 239.289H255.026L247.318 250.462V256.064H240.513Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.285 256.021L148.55 251.504H146V256.021H139.238V239.246H150.884C155.868 239.246 158.968 241.595 158.968 245.375C158.968 247.724 157.783 249.538 155.601 250.579L160.304 256.021H152.278H152.285ZM150.443 246.495C152.097 246.495 152.097 245.902 152.097 245.505C152.097 245.107 152.097 244.515 150.443 244.515H145.993V246.495H150.443Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.059 256.021V239.246H178.17V244.544H166.755V245.05H176.053V250.044H166.755V250.73H178.408V256.021H160.059Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.41 256.021V239.246H190.926C195.99 239.246 199.009 241.581 199.009 245.491C199.009 249.4 195.99 251.757 190.926 251.757H186.215V256.028H179.41V256.021ZM190.485 246.741C192.139 246.741 192.139 246.011 192.139 245.621C192.139 245.23 192.139 244.522 190.485 244.522H186.208V246.741H190.485Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.598 256.021V239.246H206.396V250.485H216.271V256.021H199.598Z"
                    fill="#004A7C"
                />
                <path
                    d="M231.015 256.021L229.757 253.368H222.974L221.717 256.021H214.5L223.039 239.246H229.75L238.289 256.021H231.007H231.015ZM227.46 248.468L226.369 246.148L225.279 248.468H227.453H227.46Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.47 256.021V250.42L232.762 239.246H240.441L243.894 244.703L247.326 239.246H254.983L247.275 250.42V256.021H240.47Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.242 255.976L148.507 251.459H145.957V255.976H139.195V239.201H150.841C155.825 239.201 158.925 241.55 158.925 245.33C158.925 247.679 157.74 249.493 155.558 250.534L160.261 255.976H152.235H152.242ZM150.4 246.45C152.054 246.45 152.054 245.858 152.054 245.46C152.054 245.063 152.054 244.47 150.4 244.47H145.95V246.45H150.4Z"
                    fill="#004A7C"
                />
                <path
                    d="M160.016 255.976V239.201H178.127V244.499H166.712V245.005H176.01V249.999H166.712V250.685H178.365V255.976H160.016Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.367 255.976V239.201H190.883C195.947 239.201 198.966 241.536 198.966 245.446C198.966 249.356 195.947 251.712 190.883 251.712H186.172V255.983H179.367V255.976ZM190.442 246.696C192.096 246.696 192.096 245.966 192.096 245.576C192.096 245.185 192.096 244.477 190.442 244.477H186.165V246.696H190.442Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.555 255.976V239.201H206.353V250.44H216.228V255.976H199.555Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.972 255.976L229.715 253.323H222.931L221.674 255.976H214.457L222.996 239.201H229.707L238.246 255.976H230.964H230.972ZM227.417 248.423L226.326 246.103L225.236 248.423H227.41H227.417Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.427 255.976V250.375L232.719 239.201H240.398L243.851 244.665L247.283 239.201H254.94L247.232 250.375V255.976H240.427Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.199 255.933L148.464 251.416H145.914V255.933H139.152V239.158H150.798C155.782 239.158 158.882 241.507 158.882 245.287C158.882 247.636 157.697 249.45 155.515 250.491L160.218 255.933H152.192H152.199ZM150.357 246.407C152.011 246.407 152.011 245.815 152.011 245.417C152.011 245.02 152.011 244.427 150.357 244.427H145.907V246.407H150.357Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.973 255.933V239.158H178.084V244.456H166.669V244.962H175.967V249.956H166.669V250.642H178.322V255.933H159.973Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.324 255.933V239.158H190.84C195.904 239.158 198.923 241.493 198.923 245.403C198.923 249.313 195.904 251.669 190.84 251.669H186.129V255.94H179.324V255.933ZM190.399 246.653C192.053 246.653 192.053 245.923 192.053 245.533C192.053 245.142 192.053 244.434 190.399 244.434H186.122V246.653H190.399Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.512 255.933V239.158H206.317V250.397H216.185V255.933H199.512Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.936 255.933L229.679 253.28H222.896L221.639 255.933H214.422L222.961 239.158H229.672L238.211 255.933H230.929H230.936ZM227.375 248.38L226.284 246.06L225.193 248.38H227.368H227.375Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.384 255.933V250.332L232.676 239.158H240.355L243.808 244.622L247.24 239.158H254.897L247.189 250.332V255.933H240.384Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.156 255.89L148.421 251.373H145.871V255.89H139.109V239.115H150.755C155.739 239.115 158.839 241.464 158.839 245.244C158.839 247.593 157.654 249.407 155.472 250.448L160.175 255.89H152.149H152.156ZM150.314 246.364C151.968 246.364 151.968 245.772 151.968 245.374C151.968 244.977 151.968 244.384 150.314 244.384H145.864V246.364H150.314Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.93 255.89V239.115H178.041V244.413H166.627V244.919H175.924V249.913H166.627V250.599H178.279V255.89H159.93Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.281 255.89V239.115H190.797C195.861 239.115 198.88 241.45 198.88 245.36C198.88 249.27 195.861 251.626 190.797 251.626H186.086V255.897H179.281V255.89ZM190.356 246.61C192.01 246.61 192.01 245.88 192.01 245.49C192.01 245.099 192.01 244.391 190.356 244.391H186.079V246.61H190.356Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.469 255.89V239.115H206.274V250.354H216.142V255.89H199.469Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.893 255.89L229.636 253.237H222.853L221.596 255.89H214.379L222.918 239.115H229.629L238.168 255.89H230.886H230.893ZM227.332 248.337L226.241 246.017L225.15 248.337H227.325H227.332Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.341 255.89V250.289L232.633 239.115H240.312L243.765 244.579L247.197 239.115H254.854L247.146 250.289V255.89H240.341Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.113 255.847L148.378 251.33H145.828V255.847H139.066V239.072H150.712C155.697 239.072 158.796 241.421 158.796 245.201C158.796 247.55 157.611 249.364 155.429 250.405L160.132 255.847H152.106H152.113ZM150.271 246.321C151.925 246.321 151.925 245.729 151.925 245.331C151.925 244.934 151.925 244.341 150.271 244.341H145.821V246.321H150.271Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.887 255.847V239.072H177.998V244.37H166.584V244.876H175.881V249.87H166.584V250.556H178.236V255.847H159.887Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.238 255.847V239.072H190.754C195.818 239.072 198.838 241.407 198.838 245.317C198.838 249.227 195.818 251.583 190.754 251.583H186.043V255.854H179.238V255.847ZM190.313 246.567C191.967 246.567 191.967 245.837 191.967 245.447C191.967 245.056 191.967 244.348 190.313 244.348H186.036V246.567H190.313Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.426 255.847V239.072H206.231V250.311H216.099V255.847H199.426Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.85 255.847L229.593 253.194H222.81L221.553 255.847H214.336L222.875 239.072H229.586L238.125 255.847H230.843H230.85ZM227.289 248.294L226.198 245.974L225.107 248.294H227.282H227.289Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.298 255.847V250.246L232.59 239.072H240.269L243.722 244.536L247.154 239.072H254.811L247.103 250.246V255.847H240.298Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.07 255.804L148.335 251.287H145.785V255.804H139.023V239.029H150.669C155.654 239.029 158.753 241.378 158.753 245.158C158.753 247.507 157.568 249.321 155.386 250.362L160.089 255.804H152.063H152.07ZM150.228 246.278C151.883 246.278 151.883 245.686 151.883 245.288C151.883 244.891 151.883 244.298 150.228 244.298H145.778V246.278H150.228Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.844 255.804V239.029H177.955V244.327H166.541V244.833H175.838V249.827H166.541V250.513H178.193V255.804H159.844Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.195 255.804V239.029H190.711C195.775 239.029 198.795 241.364 198.795 245.274C198.795 249.184 195.775 251.54 190.711 251.54H186.001V255.811H179.195V255.804ZM190.27 246.524C191.924 246.524 191.924 245.794 191.924 245.404C191.924 245.013 191.924 244.305 190.27 244.305H185.993V246.524H190.27Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.383 255.804V239.029H206.188V250.268H216.056V255.804H199.383Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.807 255.804L229.55 253.151H222.767L221.51 255.804H214.293L222.832 239.029H229.543L238.082 255.804H230.8H230.807ZM227.246 248.251L226.155 245.931L225.064 248.251H227.239H227.246Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.255 255.804V250.203L232.547 239.029H240.226L243.679 244.493L247.111 239.029H254.769L247.06 250.203V255.804H240.255Z"
                    fill="#004A7C"
                />
                <path
                    d="M152.027 255.759L148.292 251.242H145.742V255.759H138.98V238.984H150.626C155.611 238.984 158.71 241.333 158.71 245.113C158.71 247.462 157.525 249.276 155.343 250.317L160.046 255.759H152.02H152.027ZM150.185 246.233C151.84 246.233 151.84 245.641 151.84 245.243C151.84 244.846 151.84 244.253 150.185 244.253H145.735V246.233H150.185Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.801 255.759V238.984H177.912V244.282H166.498V244.788H175.802V249.782H166.498V250.469H178.15V255.759H159.801Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.152 255.759V238.984H190.668C195.732 238.984 198.752 241.319 198.752 245.229C198.752 249.139 195.732 251.495 190.668 251.495H185.958V255.766H179.152V255.759ZM190.227 246.479C191.881 246.479 191.881 245.749 191.881 245.359C191.881 244.969 191.881 244.26 190.227 244.26H185.95V246.479H190.227Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.34 255.759V238.984H206.145V250.223H216.013V255.759H199.34Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.765 255.759L229.508 253.107H222.724L221.467 255.759H214.25L222.789 238.984H229.5L238.039 255.759H230.757H230.765ZM227.203 248.206L226.112 245.886L225.021 248.206H227.196H227.203Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.212 255.759V250.158L232.504 238.984H240.183L243.636 244.448L247.068 238.984H254.726L247.017 250.158V255.759H240.212Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.984 255.716L148.249 251.199H145.699V255.716H138.938V238.941H150.583C155.568 238.941 158.667 241.29 158.667 245.07C158.667 247.419 157.482 249.233 155.3 250.274L160.003 255.716H151.977H151.984ZM150.149 246.198C151.804 246.198 151.804 245.605 151.804 245.207C151.804 244.81 151.804 244.217 150.149 244.217H145.699V246.198H150.149Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.758 255.716V238.941H177.869V244.239H166.455V244.745H175.759V249.739H166.455V250.426H178.107V255.716H159.758Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.109 255.716V238.941H190.625C195.689 238.941 198.709 241.276 198.709 245.186C198.709 249.096 195.689 251.452 190.625 251.452H185.915V255.723H179.109V255.716ZM190.184 246.436C191.838 246.436 191.838 245.706 191.838 245.316C191.838 244.926 191.838 244.217 190.184 244.217H185.907V246.436H190.184Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.297 255.716V238.941H206.102V250.18H215.97V255.716H199.297Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.722 255.716L229.465 253.064H222.681L221.424 255.716H214.207L222.746 238.941H229.457L237.996 255.716H230.714H230.722ZM227.16 248.163L226.069 245.844L224.978 248.163H227.153H227.16Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.169 255.716V250.115L232.461 238.941H240.14L243.593 244.405L247.025 238.941H254.683L246.974 250.115V255.716H240.169Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.938 255.673L148.203 251.156H145.652V255.673H138.891V238.898H150.536C155.521 238.898 158.62 241.247 158.62 245.027C158.62 247.376 157.435 249.19 155.253 250.231L159.956 255.673H151.93H151.938ZM150.103 246.155C151.757 246.155 151.757 245.562 151.757 245.165C151.757 244.767 151.757 244.174 150.103 244.174H145.652V246.155H150.103Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.711 255.673V238.898H177.822V244.196H166.408V244.702H175.713V249.696H166.408V250.383H178.06V255.673H159.711Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.062 255.673V238.898H190.578C195.642 238.898 198.662 241.233 198.662 245.143C198.662 249.053 195.642 251.409 190.578 251.409H185.868V255.68H179.062V255.673ZM190.137 246.393C191.792 246.393 191.792 245.663 191.792 245.273C191.792 244.883 191.792 244.174 190.137 244.174H185.86V246.393H190.137Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.25 255.673V238.898H206.055V250.137H215.923V255.673H199.25Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.675 255.673L229.418 253.021H222.634L221.377 255.673H214.16L222.699 238.898H229.41L237.949 255.673H230.667H230.675ZM227.113 248.12L226.022 245.801L224.931 248.12H227.106H227.113Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.122 255.673V250.072L232.414 238.898H240.093L243.547 244.362L246.978 238.898H254.636L246.927 250.072V255.673H240.122Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.895 255.63L148.16 251.113H145.61V255.63H138.848V238.855H150.493C155.478 238.855 158.577 241.204 158.577 244.984C158.577 247.333 157.392 249.147 155.21 250.188L159.913 255.63H151.887H151.895ZM150.06 246.112C151.714 246.112 151.714 245.519 151.714 245.122C151.714 244.724 151.714 244.131 150.06 244.131H145.61V246.112H150.06Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.668 255.63V238.855H177.779V244.153H166.365V244.659H175.67V249.653H166.365V250.34H178.017V255.63H159.668Z"
                    fill="#004A7C"
                />
                <path
                    d="M179.02 255.63V238.855H190.535C195.599 238.855 198.619 241.19 198.619 245.1C198.619 249.01 195.599 251.366 190.535 251.366H185.825V255.637H179.02V255.63ZM190.094 246.35C191.749 246.35 191.749 245.62 191.749 245.23C191.749 244.84 191.749 244.131 190.094 244.131H185.818V246.35H190.094Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.207 255.63V238.855H206.012V250.094H215.88V255.63H199.207Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.632 255.63L229.375 252.978H222.591L221.334 255.63H214.117L222.656 238.855H229.367L237.906 255.63H230.624H230.632ZM227.07 248.078L225.979 245.758L224.888 248.078H227.063H227.07Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.079 255.63V250.029L232.371 238.855H240.05L243.504 244.319L246.935 238.855H254.593L246.885 250.029V255.63H240.079Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.852 255.587L148.117 251.07H145.567V255.587H138.805V238.812H150.45C155.435 238.812 158.534 241.161 158.534 244.941C158.534 247.29 157.349 249.104 155.167 250.145L159.87 255.587H151.844H151.852ZM150.017 246.069C151.671 246.069 151.671 245.476 151.671 245.079C151.671 244.681 151.671 244.088 150.017 244.088H145.567V246.069H150.017Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.625 255.587V238.812H177.736V244.11H166.322V244.623H175.627V249.61H166.322V250.297H177.974V255.587H159.625Z"
                    fill="#004A7C"
                />
                <path
                    d="M178.977 255.587V238.812H190.492C195.556 238.812 198.576 241.147 198.576 245.057C198.576 248.967 195.556 251.323 190.492 251.323H185.782V255.594H178.977V255.587ZM190.051 246.307C191.706 246.307 191.706 245.577 191.706 245.187C191.706 244.797 191.706 244.088 190.051 244.088H185.775V246.307H190.051Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.164 255.587V238.812H205.969V250.051H215.845V255.587H199.164Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.589 255.587L229.332 252.935H222.548L221.291 255.587H214.074L222.613 238.812H229.325L237.863 255.587H230.582H230.589ZM227.027 248.042L225.936 245.722L224.845 248.042H227.02H227.027Z"
                    fill="#004A7C"
                />
                <path
                    d="M240.036 255.587V249.993L232.328 238.812H240.007L243.461 244.276L246.892 238.812H254.55L246.842 249.993V255.587H240.036Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.809 255.542L148.074 251.025H145.524V255.542H138.762V238.768H150.407C155.392 238.768 158.491 241.116 158.491 244.896C158.491 247.245 157.306 249.059 155.125 250.1L159.827 255.542H151.801H151.809ZM149.974 246.024C151.628 246.024 151.628 245.431 151.628 245.034C151.628 244.636 151.628 244.044 149.974 244.044H145.524V246.024H149.974Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.582 255.542V238.768H177.693V244.065H166.279V244.578H175.584V249.565H166.279V250.252H177.931V255.542H159.582Z"
                    fill="#004A7C"
                />
                <path
                    d="M178.934 255.542V238.768H190.449C195.513 238.768 198.533 241.102 198.533 245.012C198.533 248.922 195.513 251.278 190.449 251.278H185.739V255.549H178.934V255.542ZM190.008 246.262C191.663 246.262 191.663 245.532 191.663 245.142C191.663 244.752 191.663 244.044 190.008 244.044H185.732V246.262H190.008Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.121 255.542V238.768H205.926V250.006H215.802V255.542H199.121Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.546 255.542L229.289 252.89H222.505L221.248 255.542H214.031L222.57 238.768H229.282L237.821 255.542H230.539H230.546ZM226.984 247.997L225.893 245.677L224.803 247.997H226.977H226.984Z"
                    fill="#004A7C"
                />
                <path
                    d="M239.993 255.542V249.948L232.285 238.768H239.964L243.418 244.231L246.849 238.768H254.507L246.799 249.948V255.542H239.993Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.766 255.499L148.031 250.982H145.481V255.499H138.719V238.725H150.364C155.349 238.725 158.448 241.073 158.448 244.853C158.448 247.202 157.263 249.016 155.082 250.057L159.785 255.499H151.758H151.766ZM149.931 245.981C151.585 245.981 151.585 245.388 151.585 244.991C151.585 244.593 151.585 244.001 149.931 244.001H145.481V245.981H149.931Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.539 255.499V238.725H177.65V244.022H166.236V244.535H175.541V249.522H166.236V250.209H177.889V255.499H159.539Z"
                    fill="#004A7C"
                />
                <path
                    d="M178.891 255.499V238.725H190.406C195.47 238.725 198.49 241.059 198.49 244.969C198.49 248.879 195.47 251.235 190.406 251.235H185.696V255.506H178.891V255.499ZM189.965 246.219C191.62 246.219 191.62 245.489 191.62 245.099C191.62 244.709 191.62 244.001 189.965 244.001H185.689V246.219H189.965Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.078 255.499V238.725H205.883V249.963H215.759V255.499H199.078Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.503 255.499L229.246 252.847H222.462L221.205 255.499H213.988L222.527 238.725H229.239L237.778 255.499H230.496H230.503ZM226.941 247.954L225.85 245.634L224.76 247.954H226.934H226.941Z"
                    fill="#004A7C"
                />
                <path
                    d="M239.95 255.499V249.905L232.242 238.725H239.922L243.375 244.188L246.806 238.725H254.464L246.756 249.905V255.499H239.95Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.723 255.464L147.988 250.947H145.438V255.464H138.676V238.689H150.321C155.306 238.689 158.405 241.038 158.405 244.818C158.405 247.167 157.22 248.981 155.039 250.022L159.742 255.464H151.715H151.723ZM149.888 245.938C151.542 245.938 151.542 245.346 151.542 244.948C151.542 244.551 151.542 243.958 149.888 243.958H145.438V245.938H149.888Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.496 255.463V238.682H177.607V243.979H166.193V244.492H175.498V249.479H166.193V250.166H177.846V255.463H159.496Z"
                    fill="#004A7C"
                />
                <path
                    d="M178.848 255.464V238.689H190.363C195.427 238.689 198.447 241.024 198.447 244.934C198.447 248.844 195.427 251.2 190.363 251.2H185.653V255.471H178.848V255.464ZM189.922 246.177C191.577 246.177 191.577 245.447 191.577 245.057C191.577 244.666 191.577 243.958 189.922 243.958H185.646V246.177H189.922Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.035 255.463V238.682H205.84V249.92H215.716V255.463H199.035Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.46 255.464L229.203 252.812H222.419L221.162 255.464H213.945L222.484 238.689H229.196L237.735 255.464H230.453H230.46ZM226.898 247.911L225.807 245.592L224.717 247.911H226.891H226.898Z"
                    fill="#004A7C"
                />
                <path
                    d="M239.907 255.463V249.862L232.199 238.682H239.879L243.332 244.145L246.763 238.682H254.421L246.713 249.862V255.463H239.907Z"
                    fill="#004A7C"
                />
                <path
                    d="M151.723 255.464L147.988 250.947H145.438V255.464H138.676V238.689H150.321C155.306 238.689 158.405 241.038 158.405 244.818C158.405 247.167 157.22 248.981 155.039 250.022L159.742 255.464H151.715H151.723ZM149.888 245.938C151.542 245.938 151.542 245.346 151.542 244.948C151.542 244.551 151.542 243.958 149.888 243.958H145.438V245.938H149.888Z"
                    fill="#004A7C"
                />
                <path
                    d="M159.496 255.463V238.682H177.607V243.979H166.193V244.492H175.498V249.479H166.193V250.166H177.846V255.463H159.496Z"
                    fill="#004A7C"
                />
                <path
                    d="M178.848 255.464V238.689H190.363C195.427 238.689 198.447 241.024 198.447 244.934C198.447 248.844 195.427 251.2 190.363 251.2H185.653V255.471H178.848V255.464ZM189.922 246.177C191.577 246.177 191.577 245.447 191.577 245.057C191.577 244.666 191.577 243.958 189.922 243.958H185.646V246.177H189.922Z"
                    fill="#004A7C"
                />
                <path
                    d="M199.035 255.463V238.682H205.84V249.92H215.716V255.463H199.035Z"
                    fill="#004A7C"
                />
                <path
                    d="M230.46 255.464L229.203 252.812H222.419L221.162 255.464H213.945L222.484 238.689H229.196L237.735 255.464H230.453H230.46ZM226.898 247.911L225.807 245.592L224.717 247.911H226.891H226.898Z"
                    fill="#004A7C"
                />
                <path
                    d="M239.907 255.463V249.862L232.199 238.682H239.879L243.332 244.145L246.763 238.682H254.421L246.713 249.862V255.463H239.907Z"
                    fill="#004A7C"
                />
                <path
                    d="M158.197 254H151.525L147.445 249.056H143.509V254H137.701V237.2H149.629C154.117 237.2 157.669 239.12 157.669 243.128C157.669 245.888 155.989 247.664 153.469 248.504L158.197 254ZM143.509 245.144H149.149C150.661 245.144 151.741 244.712 151.741 243.272C151.741 241.832 150.661 241.4 149.149 241.4H143.509V245.144ZM166.171 249.776H178.891V254H160.435V237.2H178.627V241.424H166.171V243.56H176.323V247.448H166.171V249.776ZM193.336 237.2C198.16 237.2 201.376 239.192 201.376 243.248C201.376 247.328 198.16 249.32 193.336 249.32H187.408V254H181.552V237.2H193.336ZM192.856 245.408C194.368 245.408 195.448 244.88 195.448 243.392C195.448 241.904 194.368 241.4 192.856 241.4H187.408V245.408H192.856ZM209.439 249.512H220.215V254H203.583V237.2H209.439V249.512ZM237.597 254L236.229 251.096H227.829L226.461 254H220.365L228.885 237.2H235.245L243.765 254H237.597ZM229.605 247.304H234.453L232.029 242.12L229.605 247.304ZM240.498 237.2H246.954L251.154 243.872L255.33 237.2H261.762L254.058 248.408V254H248.202V248.408L240.498 237.2Z"
                    fill="white"
                />
                </g>
                <g id="button-green" @click="exitGame" :class="loadingAction ? 'cursor-not-allowed opacity-50 pointer-events-none' : 'cursor-pointer'">
                <path
                    d="M303.113 304.711H87.7455C79.4227 304.711 72.6758 311.461 72.6758 319.787V352.845C72.6758 361.171 79.4227 367.921 87.7455 367.921H303.113C311.436 367.921 318.183 361.171 318.183 352.845V319.787C318.183 311.461 311.436 304.711 303.113 304.711Z"
                    fill="#F7D073"
                />
                <path
                    d="M301.544 307.023H89.3262C81.4982 307.023 75.1523 313.372 75.1523 321.203V351.435C75.1523 359.267 81.4982 365.615 89.3262 365.615H301.544C309.372 365.615 315.718 359.267 315.718 351.435V321.203C315.718 313.372 309.372 307.023 301.544 307.023Z"
                    fill="#E88439"
                />
                <path
                    d="M302.905 310.797H87.9639C82.7652 310.797 78.5508 315.013 78.5508 320.214V352.737C78.5508 357.938 82.7652 362.154 87.9639 362.154H302.905C308.104 362.154 312.319 357.938 312.319 352.737V320.214C312.319 315.013 308.104 310.797 302.905 310.797Z"
                    fill="#1C5F02"
                />
                <path
                    d="M302.869 313.029H87.9929C83.9712 313.029 80.7109 316.291 80.7109 320.314V352.635C80.7109 356.658 83.9712 359.92 87.9929 359.92H302.869C306.891 359.92 310.151 356.658 310.151 352.635V320.314C310.151 316.291 306.891 313.029 302.869 313.029Z"
                    fill="#4D8213"
                />
                <path
                    d="M305.11 354.99C305.11 354.99 305.074 359.175 302.856 359.919H88.0157C85.7978 359.175 85.7617 354.99 85.7617 354.99L90.2552 350.553H300.602L305.103 354.99H305.11Z"
                    fill="#1C5F02"
                />
                <path
                    d="M90.2619 322.707V350.546L85.7685 354.984C81.8385 354.644 80.7188 352.635 80.7188 352.635V320.3C80.7188 320.3 81.8385 318.291 85.7685 317.951L90.2619 322.707Z"
                    fill="#67AD19"
                />
                <path
                    d="M305.111 317.958L300.61 322.714H90.263L85.7695 317.958C85.7695 317.958 85.8057 313.774 88.0235 313.029H302.864C305.082 313.774 305.118 317.958 305.118 317.958H305.111Z"
                    fill="#8BD828"
                />
                <path
                    d="M88.0146 313.029C85.7968 313.774 85.7607 317.958 85.7607 317.958C81.8307 318.298 80.7109 320.307 80.7109 320.307C80.7109 316.289 83.9691 313.029 87.9857 313.029H88.0074H88.0146Z"
                    fill="#5EA11D"
                />
                <path
                    d="M310.152 352.643C310.152 356.661 306.894 359.92 302.877 359.92H302.855C305.073 359.176 305.109 354.991 305.109 354.991C309.039 354.652 310.159 352.643 310.159 352.643H310.152Z"
                    fill="#5EA11D"
                />
                <path
                    d="M310.151 320.307C310.151 320.307 309.032 318.298 305.102 317.958C305.102 317.958 305.065 313.774 302.848 313.029H302.869C306.886 313.029 310.144 316.289 310.144 320.307H310.151Z"
                    fill="#5EA11D"
                />
                <path
                    d="M88.0152 359.92H87.9935C83.9769 359.92 80.7188 356.661 80.7188 352.643C80.7188 352.643 81.8385 354.645 85.7685 354.991C85.7685 354.991 85.8046 359.176 88.0224 359.92H88.0152Z"
                    fill="#5EA11D"
                />
                <path d="M300.605 322.707H90.2578V350.547H300.605V322.707Z" fill="#67AA26" />
                <path
                    d="M165.234 346.911V330.129H183.345V335.427H171.931V335.94H181.229V340.927H171.931V341.613H183.584V346.911H165.234Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.694 346.911L193.263 342.914L189.831 346.911H181.906L189.419 338.39L182.072 330.129H190.38L193.617 333.887L196.846 330.129H204.821L197.438 338.31L204.966 346.911H196.694Z"
                    fill="#1C5F02"
                />
                <path d="M210.825 330.129H204.02V346.903H210.825V330.129Z" fill="#1C5F02" />
                <path
                    d="M217.349 346.911V335.622H211.273V330.129H230.244V335.622H224.147V346.911H217.349Z"
                    fill="#1C5F02"
                />
                <path
                    d="M165.188 346.868V330.086H183.299V335.384H171.884V335.897H181.182V340.884H171.884V341.57H183.537V346.868H165.188Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.647 346.868L193.216 342.871L189.784 346.868H181.859L189.373 338.347L182.026 330.086H190.333L193.57 333.844L196.799 330.086H204.775L197.391 338.267L204.919 346.868H196.647Z"
                    fill="#1C5F02"
                />
                <path d="M210.778 330.086H203.973V346.861H210.778V330.086Z" fill="#1C5F02" />
                <path
                    d="M217.302 346.868V335.579H211.227V330.086H230.197V335.579H224.1V346.868H217.302Z"
                    fill="#1C5F02"
                />
                <path
                    d="M165.145 346.825V330.043H183.256V335.341H171.841V335.854H181.139V340.841H171.841V341.527H183.494V346.825H165.145Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.604 346.825L193.173 342.828L189.741 346.825H181.816L189.33 338.304L181.983 330.043H190.29L193.527 333.801L196.756 330.043H204.732L197.348 338.224L204.876 346.825H196.604Z"
                    fill="#1C5F02"
                />
                <path d="M210.735 330.043H203.93V346.818H210.735V330.043Z" fill="#1C5F02" />
                <path
                    d="M217.259 346.825V335.536H211.184V330.043H230.154V335.536H224.057V346.825H217.259Z"
                    fill="#1C5F02"
                />
                <path
                    d="M165.102 346.782V330H183.213V335.298H171.798V335.811H181.096V340.798H171.798V341.484H183.451V346.782H165.102Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.561 346.782L193.13 342.785L189.698 346.782H181.773L189.287 338.261L181.94 330H190.247L193.484 333.758L196.713 330H204.689L197.305 338.181L204.833 346.782H196.561Z"
                    fill="#1C5F02"
                />
                <path d="M210.692 330H203.887V346.775H210.692V330Z" fill="#1C5F02" />
                <path
                    d="M217.216 346.782V335.493H211.141V330H230.111V335.493H224.014V346.782H217.216Z"
                    fill="#1C5F02"
                />
                <path
                    d="M165.059 346.739V329.957H183.17V335.255H171.755V335.768H181.053V340.755H171.755V341.441H183.408V346.739H165.059Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.518 346.739L193.087 342.742L189.655 346.739H181.73L189.244 338.218L181.897 329.957H190.204L193.441 333.715L196.67 329.957H204.646L197.262 338.138L204.79 346.739H196.518Z"
                    fill="#1C5F02"
                />
                <path d="M210.649 329.957H203.844V346.732H210.649V329.957Z" fill="#1C5F02" />
                <path
                    d="M217.174 346.739V335.45H211.105V329.957H230.069V335.45H223.972V346.739H217.174Z"
                    fill="#1C5F02"
                />
                <path
                    d="M165.016 346.694V329.912H183.127V335.21H171.712V335.723H181.01V340.71H171.712V341.396H183.365V346.694H165.016Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.475 346.694L193.044 342.697L189.612 346.694H181.688L189.201 338.173L181.854 329.912H190.161L193.398 333.67L196.627 329.912H204.603L197.22 338.093L204.747 346.694H196.475Z"
                    fill="#1C5F02"
                />
                <path d="M210.606 329.912H203.801V346.687H210.606V329.912Z" fill="#1C5F02" />
                <path
                    d="M217.131 346.694V335.405H211.062V329.912H230.026V335.405H223.929V346.694H217.131Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.973 346.651V329.869H183.084V335.167H171.67V335.68H180.967V340.667H171.67V341.353H183.322V346.651H164.973Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.432 346.651L193.001 342.654L189.569 346.651H181.645L189.158 338.13L181.811 329.869H190.119L193.355 333.627L196.584 329.869H204.56L197.177 338.05L204.704 346.651H196.432Z"
                    fill="#1C5F02"
                />
                <path d="M210.563 329.869H203.758V346.644H210.563V329.869Z" fill="#1C5F02" />
                <path
                    d="M217.088 346.651V335.362H211.02V329.869H229.983V335.362H223.893V346.651H217.088Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.93 346.609V329.834H183.041V335.124H171.627V335.638H180.924V340.624H171.627V341.311H183.279V346.609H164.93Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.389 346.609L192.958 342.612L189.526 346.609H181.602L189.115 338.088L181.768 329.834H190.076L193.312 333.585L196.541 329.834H204.517L197.134 338.008L204.661 346.609H196.389Z"
                    fill="#1C5F02"
                />
                <path d="M210.52 329.834H203.715V346.609H210.52V329.834Z" fill="#1C5F02" />
                <path
                    d="M217.045 346.609V335.32H210.977V329.834H229.94V335.32H223.85V346.609H217.045Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.887 346.564V329.789H182.998V335.079H171.584V335.593H180.881V340.579H171.584V341.266H183.236V346.564H164.887Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.347 346.564L192.915 342.567L189.484 346.564H181.559L189.072 338.043L181.725 329.789H190.033L193.269 333.54L196.498 329.789H204.474L197.091 337.963L204.618 346.564H196.347Z"
                    fill="#1C5F02"
                />
                <path d="M210.477 329.789H203.672V346.564H210.477V329.789Z" fill="#1C5F02" />
                <path
                    d="M217.002 346.564V335.275H210.934V329.789H229.897V335.275H223.807V346.564H217.002Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.844 346.521V329.746H182.955V335.036H171.541V335.55H180.838V340.536H171.541V341.223H183.193V346.521H164.844Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.304 346.521L192.872 342.524L189.441 346.521H181.516L189.029 338L181.682 329.746H189.99L193.226 333.497L196.455 329.746H204.431L197.048 337.92L204.575 346.521H196.304Z"
                    fill="#1C5F02"
                />
                <path d="M210.434 329.746H203.629V346.521H210.434V329.746Z" fill="#1C5F02" />
                <path
                    d="M216.959 346.521V335.239H210.891V329.746H229.854V335.239H223.764V346.521H216.959Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.801 346.478V329.703H182.912V334.994H171.498V335.507H180.802V340.493H171.498V341.18H183.15V346.478H164.801Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.261 346.478L192.829 342.481L189.398 346.478H181.473L188.986 337.957L181.639 329.703H189.947L193.183 333.461L196.412 329.703H204.388L197.005 337.877L204.532 346.478H196.261Z"
                    fill="#1C5F02"
                />
                <path d="M210.391 329.703H203.586V346.478H210.391V329.703Z" fill="#1C5F02" />
                <path
                    d="M216.916 346.478V335.196H210.848V329.703H229.811V335.196H223.721V346.478H216.916Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.754 346.435V329.66H182.865V334.951H171.451V335.464H180.755V340.451H171.451V341.137H183.103V346.435H164.754Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.214 346.435L192.782 342.438L189.351 346.435H181.426L188.939 337.914L181.592 329.66H189.9L193.136 333.418L196.365 329.66H204.341L196.958 337.834L204.485 346.435H196.214Z"
                    fill="#1C5F02"
                />
                <path d="M210.344 329.66H203.539V346.435H210.344V329.66Z" fill="#1C5F02" />
                <path
                    d="M216.869 346.435V335.153H210.801V329.66H229.764V335.153H223.674V346.435H216.869Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.711 346.392V329.617H182.822V334.908H171.408V335.421H180.713V340.408H171.408V341.094H183.06V346.392H164.711Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.171 346.392L192.739 342.395L189.308 346.392H181.383L188.896 337.878L181.549 329.617H189.857L193.093 333.375L196.322 329.617H204.298L196.915 337.791L204.442 346.392H196.171Z"
                    fill="#1C5F02"
                />
                <path d="M210.301 329.617H203.496V346.392H210.301V329.617Z" fill="#1C5F02" />
                <path
                    d="M216.826 346.392V335.11H210.758V329.617H229.721V335.11H223.631V346.392H216.826Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.668 346.347V329.572H182.779V334.863H171.365V335.376H180.67V340.363H171.365V341.049H183.017V346.347H164.668Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.128 346.347L192.696 342.35L189.265 346.347H181.34L188.853 337.833L181.506 329.572H189.814L193.05 333.33L196.279 329.572H204.255L196.872 337.746L204.399 346.347H196.128Z"
                    fill="#1C5F02"
                />
                <path d="M210.258 329.572H203.453V346.347H210.258V329.572Z" fill="#1C5F02" />
                <path
                    d="M216.783 346.347V335.065H210.715V329.572H229.678V335.065H223.588V346.347H216.783Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.625 346.304V329.529H182.736V334.82H171.322V335.333H180.627V340.32H171.322V341.006H182.974V346.304H164.625Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.085 346.304L192.653 342.307L189.222 346.304H181.297L188.81 337.79L181.463 329.529H189.778L193.007 333.287L196.237 329.529H204.212L196.829 337.703L204.357 346.304H196.085Z"
                    fill="#1C5F02"
                />
                <path d="M210.215 329.529H203.41V346.304H210.215V329.529Z" fill="#1C5F02" />
                <path
                    d="M216.74 346.304V335.022H210.672V329.529H229.635V335.022H223.545V346.304H216.74Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.582 346.261V329.486H182.693V334.777H171.279V335.29H180.584V340.277H171.279V340.963H182.932V346.261H164.582Z"
                    fill="#1C5F02"
                />
                <path
                    d="M196.042 346.261L192.61 342.264L189.179 346.261H181.254L188.774 337.747L181.42 329.486H189.735L192.964 333.245L196.194 329.486H204.169L196.786 337.66L204.314 346.261H196.042Z"
                    fill="#1C5F02"
                />
                <path d="M210.172 329.486H203.367V346.261H210.172V329.486Z" fill="#1C5F02" />
                <path
                    d="M216.697 346.261V334.979H210.629V329.486H229.592V334.979H223.502V346.261H216.697Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.539 346.218V329.443H182.65V334.734H171.236V335.247H180.541V340.234H171.236V340.928H182.889V346.218H164.539Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.999 346.218L192.567 342.221L189.136 346.218H181.211L188.731 337.704L181.377 329.443H189.692L192.921 333.202L196.151 329.443H204.126L196.743 337.617L204.271 346.218H195.999Z"
                    fill="#1C5F02"
                />
                <path d="M210.129 329.443H203.324V346.218H210.129V329.443Z" fill="#1C5F02" />
                <path
                    d="M216.654 346.218V334.936H210.586V329.443H229.549V334.936H223.459V346.218H216.654Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.496 346.175V329.4H182.607V334.691H171.193V335.204H180.498V340.191H171.193V340.885H182.846V346.175H164.496Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.956 346.175L192.524 342.178L189.1 346.175H181.168L188.688 337.661L181.334 329.4H189.649L192.878 333.159L196.115 329.4H204.083L196.7 337.574L204.228 346.175H195.956Z"
                    fill="#1C5F02"
                />
                <path d="M210.086 329.4H203.281V346.175H210.086V329.4Z" fill="#1C5F02" />
                <path
                    d="M216.611 346.175V334.893H210.543V329.4H229.506V334.893H223.416V346.175H216.611Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.453 346.13V329.355H182.564V334.653H171.15V335.159H180.455V340.146H171.15V340.84H182.803V346.13H164.453Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.913 346.13L192.481 342.133L189.057 346.13H181.125L188.645 337.616L181.291 329.355H189.606L192.835 333.114L196.072 329.355H204.04L196.657 337.53L204.185 346.13H195.913Z"
                    fill="#1C5F02"
                />
                <path d="M210.051 329.355H203.246V346.13H210.051V329.355Z" fill="#1C5F02" />
                <path
                    d="M216.568 346.13V334.848H210.5V329.355H229.464V334.848H223.374V346.13H216.568Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.41 346.087V329.312H182.521V334.61H171.107V335.116H180.412V340.103H171.107V340.797H182.767V346.087H164.41Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.87 346.087L192.438 342.09L189.014 346.087H181.082L188.602 337.573L181.248 329.312H189.563L192.792 333.071L196.029 329.312H203.997L196.614 337.487L204.142 346.087H195.87Z"
                    fill="#1C5F02"
                />
                <path d="M210.008 329.312H203.203V346.087H210.008V329.312Z" fill="#1C5F02" />
                <path
                    d="M216.525 346.087V334.805H210.457V329.312H229.421V334.805H223.331V346.087H216.525Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.371 346.044V329.27H182.475V334.567H171.061V335.073H180.365V340.067H171.061V340.754H182.721V346.044H164.371Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.827 346.044L192.396 342.047L188.971 346.044H181.039L188.559 337.53L181.205 329.27H189.52L192.75 333.028L195.986 329.27H203.954L196.571 337.444L204.099 346.044H195.827Z"
                    fill="#1C5F02"
                />
                <path d="M209.961 329.27H203.156V346.044H209.961V329.27Z" fill="#1C5F02" />
                <path
                    d="M216.478 346.044V334.762H210.41V329.27H229.374V334.762H223.284V346.044H216.478Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.328 346.001V329.227H182.432V334.524H171.018V335.03H180.322V340.024H171.018V340.711H182.678V346.001H164.328Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.784 346.001L192.36 342.004L188.928 346.001H180.996L188.516 337.487L181.162 329.227H189.477L192.707 332.985L195.943 329.227H203.918L196.528 337.401L204.056 346.001H195.784Z"
                    fill="#1C5F02"
                />
                <path d="M209.918 329.227H203.113V346.001H209.918V329.227Z" fill="#1C5F02" />
                <path
                    d="M216.436 346.001V334.719H210.367V329.227H229.331V334.719H223.241V346.001H216.436Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.285 345.958V329.184H182.389V334.481H170.975V334.987H180.28V339.981H170.975V340.668H182.635V345.958H164.285Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.741 345.958L192.317 341.961L188.885 345.958H180.953L188.474 337.444L181.119 329.184H189.434L192.664 332.942L195.9 329.184H203.876L196.485 337.358L204.013 345.958H195.741Z"
                    fill="#1C5F02"
                />
                <path d="M209.876 329.184H203.07V345.958H209.876V329.184Z" fill="#1C5F02" />
                <path
                    d="M216.393 345.958V334.676H210.324V329.184H229.288V334.676H223.198V345.958H216.393Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.242 345.913V329.139H182.346V334.436H170.932V334.942H180.237V339.936H170.932V340.623H182.592V345.913H164.242Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.698 345.913L192.274 341.917L188.842 345.913H180.91L188.431 337.399L181.076 329.139H189.391L192.621 332.897L195.857 329.139H203.833L196.442 337.313L203.97 345.913H195.698Z"
                    fill="#1C5F02"
                />
                <path d="M209.833 329.139H203.027V345.913H209.833V329.139Z" fill="#1C5F02" />
                <path
                    d="M216.35 345.913V334.631H210.281V329.139H229.245V334.631H223.155V345.913H216.35Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.199 345.87V329.096H182.303V334.393H170.889V334.899H180.194V339.893H170.889V340.58H182.549V345.87H164.199Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.655 345.87L192.231 341.874L188.799 345.87H180.867L188.388 337.357L181.033 329.096H189.348L192.578 332.854L195.814 329.096H203.79L196.399 337.27L203.927 345.87H195.655Z"
                    fill="#1C5F02"
                />
                <path d="M209.79 329.096H202.984V345.87H209.79V329.096Z" fill="#1C5F02" />
                <path
                    d="M216.307 345.87V334.588H210.238V329.096H229.202V334.588H223.112V345.87H216.307Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.156 345.827V329.053H182.26V334.35H170.846V334.863H180.151V339.85H170.846V340.537H182.506V345.827H164.156Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.612 345.827L192.188 341.831L188.756 345.827H180.824L188.345 337.314L180.998 329.053H189.305L192.535 332.811L195.771 329.053H203.747L196.356 337.227L203.884 345.827H195.612Z"
                    fill="#1C5F02"
                />
                <path d="M209.747 329.053H202.941V345.827H209.747V329.053Z" fill="#1C5F02" />
                <path
                    d="M216.264 345.827V334.545H210.195V329.053H229.159V334.545H223.069V345.827H216.264Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.113 345.784V329.01H182.217V334.307H170.803V334.821H180.108V339.807H170.803V340.494H182.463V345.784H164.113Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.569 345.784L192.145 341.788L188.713 345.784H180.781L188.302 337.271L180.955 329.01H189.262L192.492 332.768L195.728 329.01H203.704L196.313 337.184L203.841 345.784H195.569Z"
                    fill="#1C5F02"
                />
                <path d="M209.704 329.01H202.898V345.784H209.704V329.01Z" fill="#1C5F02" />
                <path
                    d="M216.221 345.784V334.503H210.152V329.01H229.116V334.503H223.026V345.784H216.221Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.07 345.741V328.967H182.174V334.264H170.76V334.778H180.065V339.764H170.76V340.451H182.42V345.741H164.07Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.526 345.741L192.102 341.745L188.67 345.741H180.738L188.259 337.228L180.912 328.967H189.219L192.449 332.725L195.685 328.967H203.661L196.27 337.141L203.805 345.741H195.526Z"
                    fill="#1C5F02"
                />
                <path d="M209.661 328.967H202.855V345.741H209.661V328.967Z" fill="#1C5F02" />
                <path
                    d="M216.178 345.741V334.46H210.109V328.967H229.073V334.46H222.983V345.741H216.178Z"
                    fill="#1C5F02"
                />
                <path
                    d="M164.027 345.696V328.922H182.131V334.22H170.717V334.733H180.022V339.719H170.717V340.406H182.377V345.696H164.027Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.49 345.696L192.059 341.7L188.627 345.696H180.695L188.216 337.183L180.869 328.922H189.177L192.406 332.68L195.642 328.922H203.618L196.227 337.103L203.762 345.696H195.49Z"
                    fill="#1C5F02"
                />
                <path d="M209.618 328.922H202.812V345.696H209.618V328.922Z" fill="#1C5F02" />
                <path
                    d="M216.135 345.696V334.415H210.066V328.922H229.03V334.415H222.94V345.696H216.135Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.984 345.654V328.879H182.088V334.177H170.674V334.69H179.979V339.677H170.674V340.363H182.334V345.654H163.984Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.447 345.654L192.016 341.657L188.584 345.654H180.652L188.173 337.14L180.826 328.879H189.134L192.363 332.637L195.599 328.879H203.575L196.184 337.06L203.719 345.654H195.447Z"
                    fill="#1C5F02"
                />
                <path d="M209.575 328.879H202.77V345.654H209.575V328.879Z" fill="#1C5F02" />
                <path
                    d="M216.092 345.654V334.372H210.023V328.879H228.987V334.372H222.897V345.654H216.092Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.938 345.618V328.836H182.041V334.134H170.627V334.647H179.932V339.634H170.627V340.32H182.287V345.618H163.938Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.401 345.618L191.969 341.614L188.538 345.618H180.605L188.126 337.097L180.779 328.836H189.087L192.316 332.594L195.552 328.836H203.528L196.137 337.017L203.672 345.618H195.401Z"
                    fill="#1C5F02"
                />
                <path d="M209.528 328.836H202.723V345.611H209.528V328.836Z" fill="#1C5F02" />
                <path
                    d="M216.045 345.618V334.329H209.977V328.836H228.94V334.329H222.85V345.618H216.045Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.895 345.575V328.793H181.998V334.091H170.584V334.604H179.889V339.591H170.584V340.277H182.244V345.575H163.895Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.358 345.575L191.926 341.578L188.495 345.575H180.562L188.083 337.054L180.736 328.793H189.044L192.273 332.551L195.509 328.793H203.485L196.095 336.974L203.629 345.575H195.358Z"
                    fill="#1C5F02"
                />
                <path d="M209.485 328.793H202.68V345.568H209.485V328.793Z" fill="#1C5F02" />
                <path
                    d="M216.002 345.575V334.286H209.934V328.793H228.897V334.286H222.807V345.575H216.002Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.852 345.532V328.75H181.955V334.048H170.541V334.561H179.846V339.548H170.541V340.234H182.201V345.532H163.852Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.315 345.532L191.883 341.535L188.452 345.532H180.52L188.04 337.011L180.693 328.75H189.001L192.23 332.508L195.466 328.75H203.442L196.052 336.931L203.586 345.532H195.315Z"
                    fill="#1C5F02"
                />
                <path d="M209.442 328.75H202.637V345.525H209.442V328.75Z" fill="#1C5F02" />
                <path
                    d="M215.959 345.532V334.243H209.891V328.75H228.854V334.243H222.764V345.532H215.959Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.809 345.487V328.705H181.912V334.003H170.498V334.516H179.803V339.503H170.498V340.189H182.158V345.487H163.809Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.268 345.487L191.836 341.49L188.405 345.487H180.473L187.993 336.966L180.646 328.705H188.954L192.183 332.463L195.42 328.705H203.395L196.005 336.886L203.54 345.487H195.268Z"
                    fill="#1C5F02"
                />
                <path d="M209.399 328.705H202.594V345.48H209.399V328.705Z" fill="#1C5F02" />
                <path
                    d="M215.916 345.487V334.198H209.848V328.705H228.811V334.198H222.721V345.487H215.916Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.766 345.444V328.662H181.869V333.96H170.455V334.473H179.76V339.46H170.455V340.146H182.115V345.444H163.766Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.225 345.444L191.794 341.447L188.362 345.444H180.438L187.951 336.923L180.604 328.662H188.911L192.141 332.42L195.377 328.662H203.353L195.97 336.843L203.497 345.444H195.225Z"
                    fill="#1C5F02"
                />
                <path d="M209.356 328.662H202.551V345.437H209.356V328.662Z" fill="#1C5F02" />
                <path
                    d="M215.873 345.444V334.155H209.805V328.662H228.775V334.155H222.678V345.444H215.873Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.723 345.401V328.619H181.826V333.917H170.412V334.43H179.717V339.417H170.412V340.103H182.072V345.401H163.723Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.182 345.401L191.751 341.404L188.319 345.401H180.395L187.908 336.88L180.561 328.619H188.869L192.105 332.377L195.334 328.619H203.31L195.927 336.8L203.454 345.401H195.182Z"
                    fill="#1C5F02"
                />
                <path d="M209.313 328.619H202.508V345.394H209.313V328.619Z" fill="#1C5F02" />
                <path
                    d="M215.83 345.401V334.112H209.762V328.619H228.732V334.112H222.635V345.401H215.83Z"
                    fill="#1C5F02"
                />
                <path
                    d="M163.723 345.401V328.619H181.826V333.917H170.412V334.43H179.717V339.417H170.412V340.103H182.072V345.401H163.723Z"
                    fill="#1C5F02"
                />
                <path
                    d="M195.182 345.401L191.751 341.404L188.319 345.401H180.395L187.908 336.88L180.561 328.619H188.869L192.105 332.377L195.334 328.619H203.31L195.927 336.8L203.454 345.401H195.182Z"
                    fill="#1C5F02"
                />
                <path d="M209.313 328.619H202.508V345.394H209.313V328.619Z" fill="#1C5F02" />
                <path
                    d="M215.83 345.401V334.112H209.762V328.619H228.732V334.112H222.635V345.401H215.83Z"
                    fill="#1C5F02"
                />
                <path
                    d="M169.218 338.776H181.938V343H163.482V326.2H181.674V330.424H169.218V332.56H179.37V336.448H169.218V338.776ZM204.135 326.2L196.791 334.36L204.327 343H197.391L193.287 338.2L189.183 343H182.631L190.143 334.456L182.823 326.2H189.783L193.671 330.736L197.559 326.2H204.135ZM211.666 343H205.81V326.2H211.666V343ZM232.851 326.2V330.64H226.203V343H220.347V330.64H213.723V326.2H232.851Z"
                    fill="white"
                />
                </g>
                <defs>
                    <filter
                        id="filter0_d_26148_72345"
                        x="-20.1334"
                        y="6.26695"
                        width="431.138"
                        height="503.253"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="8.5" />
                        <feGaussianBlur stdDeviation="22.68" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.72 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_26148_72345"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_26148_72345"
                            result="shape"
                        />
                    </filter>
                    <linearGradient
                        id="paint0_linear_26148_72345"
                        x1="25.2193"
                        y1="249.393"
                        x2="365.638"
                        y2="249.393"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#EAB240" />
                        <stop offset="0.48" stop-color="#E4C072" />
                        <stop offset="1" stop-color="#EAB13E" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    </div>
</template>

<script>
import { useMatchStore } from '@/stores/match.js'

export default {
    name: 'MatchOverModal',
    components: {  },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        matchData: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        isVisible: {
            immediate: true,
            async handler(newValue) {
                if (!newValue) {
                    this.loadingAction = null
                    return
                }
                if (this.matchStore.match.id) {
                    try {
                        await this.matchStore.endMatch(this.matchStore.match.id)
                    } catch (error) {
                        console.error('Failed to end match:', error)
                    }
                }
            },
        },
    },
    data() {
        return {
            loadingAction: null,
        }
    },
    computed: {
        matchStore() {
            return useMatchStore()
        },
    },
    methods: {

        replayGame() {
            if (this.loadingAction) return
            this.loadingAction = 'replay'
            this.$emit('rematch')
        },

        newGame() {
            if (this.loadingAction) return
            this.loadingAction = 'new-game'
            this.$emit('new-game')
        },

        exitGame() {
            if (this.loadingAction) return
            this.loadingAction = 'exit'
            this.$emit('exit')
        },

        rematch() {
            this.$emit('rematch')
        },

        showGameStats() {
            this.$emit('show-game-stats')
        },
    },
}
</script>
